
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fPkhr", function(module, exports) {
function $b85b59ac70a06546$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $b85b59ac70a06546$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $b85b59ac70a06546$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $b85b59ac70a06546$export$967a6b9924a689f7(a, b);
    return $b85b59ac70a06546$export$3e67810a3f0e9f1c(a, b);
}
module.exports["shallowEqualObjects"] = $b85b59ac70a06546$export$3e67810a3f0e9f1c;

});

parcelRegister("jwnhU", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");

const $4a05ec1492884d39$export$6be90bcb437e928f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $c0qxy.useId)()}${postfix}`;
    (0, $42omo.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $4a05ec1492884d39$export$6be90bcb437e928f;

});

parcelRegister("eKXGE", function(module, exports) {
function $6ab331f7326b3ca4$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $6ab331f7326b3ca4$export$e618dc39ac9ad607;

});

parcelRegister("alaek", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");

var $esRft = parcelRequire("esRft");


var $dh538 = parcelRequire("dh538");


var $cmDjE = parcelRequire("cmDjE");

const $21bae01687242d76$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $21bae01687242d76$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
const $21bae01687242d76$var$TeamAvatar = (0, $4pOgL.isReactCompilerActivePlatform)() ? function TeamAvatar(t0) {
    const $ = (0, $frIzR.c)(31);
    let props;
    let src;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ testId: testId, src: src, size: t1, teamId: t2, compact: t3, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = src;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = testId;
    } else {
        props = $[1];
        src = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        testId = $[6];
    }
    const size = t1 === undefined ? "medium" : t1;
    let teamId = t2 === undefined ? "" : t2;
    const compact = t3 === undefined ? false : t3;
    let t4;
    if ($[7] !== teamId) {
        t4 = teamId.replace("ari:cloud:identity::team/", "");
        $[7] = teamId;
        $[8] = t4;
    } else t4 = $[8];
    teamId = t4;
    if ((0, $dh538.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t5 = `${testId}-team-avatar`;
        let t6;
        if ($[9] !== size || $[10] !== src || $[11] !== teamId || $[12] !== testId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmDjE.TeamAvatarImage), {
                key: teamId,
                src: src,
                size: size,
                testId: testId,
                teamId: teamId
            }));
            $[9] = size;
            $[10] = src;
            $[11] = teamId;
            $[12] = testId;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== props || $[15] !== size || $[16] !== t5 || $[17] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                ...props,
                appearance: "square",
                size: size,
                testId: t5
            }, t6);
            $[14] = props;
            $[15] = size;
            $[16] = t5;
            $[17] = t6;
            $[18] = t7;
        } else t7 = $[18];
        return t7;
    }
    const t5 = `${testId}-team-avatar`;
    let t6;
    if ($[19] !== compact || $[20] !== size || $[21] !== src || $[22] !== teamId || $[23] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmDjE.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        });
        $[19] = compact;
        $[20] = size;
        $[21] = src;
        $[22] = teamId;
        $[23] = testId;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== props || $[26] !== size || $[27] !== src || $[28] !== t5 || $[29] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            appearance: "square",
            ...props,
            size: size,
            src: src,
            testId: t5
        }, t6);
        $[25] = props;
        $[26] = size;
        $[27] = src;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : function TeamAvatar({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    if ((0, $dh538.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmDjE.TeamAvatarImage), {
        key: teamId,
        src: src,
        size: size,
        testId: testId,
        teamId: teamId
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmDjE.TeamAvatarImage), {
        src: src,
        size: size,
        testId: testId,
        teamId: teamId,
        compact: compact
    }));
};
var $21bae01687242d76$export$2e2bcd8739ae039 = $21bae01687242d76$var$TeamAvatar;
module.exports["default"] = $21bae01687242d76$export$2e2bcd8739ae039;

});

parcelRegister("cmDjE", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $5P3yi = parcelRequire("5P3yi");


var $asaw9 = parcelRequire("asaw9");


var $f2BEc = parcelRequire("f2BEc");

const $bdf91181004cdb95$var$boxShadowCssVar = '--avatar-box-shadow';
const $bdf91181004cdb95$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $bdf91181004cdb95$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $bdf91181004cdb95$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $bdf91181004cdb95$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $bdf91181004cdb95$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $bdf91181004cdb95$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $bdf91181004cdb95$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $bdf91181004cdb95$export$ac3673635a5387be = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { alt: t1, src: src, size: size, testId: testId, teamId: teamId, compact: t2 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const compact = t2 === undefined ? false : t2;
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    let t3;
    if ($[0] !== src || $[1] !== teamId) {
        t3 = (0, $f2BEc.getTeamAvatarSrc)(src, teamId);
        $[0] = src;
        $[1] = teamId;
        $[2] = t3;
    } else t3 = $[2];
    const avatarSrc = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if ((0, $dh538.fg)("enable_teams_t26_design_drop_core_experiences")) return;
            setHasImageErrored(false);
        };
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== avatarSrc) {
        t5 = [
            avatarSrc
        ];
        $[4] = avatarSrc;
        $[5] = t5;
    } else t5 = $[5];
    (0, $42omo.useEffect)(t4, t5);
    if ((!avatarSrc || hasImageErrored) && !(0, $dh538.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t6 = $bdf91181004cdb95$var$SIZES[size];
        const t7 = $bdf91181004cdb95$var$SIZES[size];
        let t8;
        if ($[6] !== alt || $[7] !== compact || $[8] !== t6 || $[9] !== t7 || $[10] !== testId) {
            t8 = /*#__PURE__*/ $42omo.createElement((0, $5P3yi.FallbackAvatar), {
                "aria-label": alt,
                width: t6,
                height: t7,
                "data-testid": testId,
                compact: compact
            });
            $[6] = alt;
            $[7] = compact;
            $[8] = t6;
            $[9] = t7;
            $[10] = testId;
            $[11] = t8;
        } else t8 = $[11];
        return t8;
    }
    if ((0, $dh538.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const resolvedSrc = hasImageErrored ? (0, $asaw9.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        const t6 = testId && `${testId}--image`;
        let t7;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = ()=>setHasImageErrored(true);
            $[12] = t7;
        } else t7 = $[12];
        let t8;
        if ($[13] !== alt || $[14] !== resolvedSrc || $[15] !== t6) {
            t8 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                as: "img",
                src: resolvedSrc,
                alt: alt,
                testId: t6,
                xcss: $bdf91181004cdb95$var$avatarImageStyles.image,
                onError: t7
            });
            $[13] = alt;
            $[14] = resolvedSrc;
            $[15] = t6;
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    const t6 = $bdf91181004cdb95$var$borderRadiusMap[size];
    const t7 = $bdf91181004cdb95$var$widthHeightMap[size];
    const t8 = compact ? $bdf91181004cdb95$var$containerStyles.compactSpacing : $bdf91181004cdb95$var$containerStyles.nonCompactSpacing;
    let t9;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = (0, $gMc0m.default)([
            $bdf91181004cdb95$var$unboundStyles.root,
            $bdf91181004cdb95$var$containerStyles.root,
            t6,
            t7,
            t8
        ]);
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    const t10 = testId && `${testId}--image`;
    let t11;
    let t12;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>setHasImageErrored(true);
        t12 = (0, $gMc0m.default)([
            $bdf91181004cdb95$var$avatarImageStyles.image
        ]);
        $[21] = t11;
        $[22] = t12;
    } else {
        t11 = $[21];
        t12 = $[22];
    }
    let t13;
    if ($[23] !== alt || $[24] !== avatarSrc || $[25] !== t10) {
        t13 = /*#__PURE__*/ $42omo.createElement("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": t10,
            onError: t11,
            className: t12
        });
        $[23] = alt;
        $[24] = avatarSrc;
        $[25] = t10;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== alt || $[28] !== t13 || $[29] !== t9 || $[30] !== testId) {
        t14 = /*#__PURE__*/ $42omo.createElement("span", {
            "data-testid": testId,
            "aria-label": alt,
            className: t9
        }, t13);
        $[27] = alt;
        $[28] = t13;
        $[29] = t9;
        $[30] = testId;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const avatarSrc = (0, $f2BEc.getTeamAvatarSrc)(src, teamId);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('enable_teams_t26_design_drop_core_experiences')) return;
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if ((!avatarSrc || hasImageErrored) && !(0, $dh538.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ $42omo.createElement((0, $5P3yi.FallbackAvatar), {
        "aria-label": alt,
        width: $bdf91181004cdb95$var$SIZES[size],
        height: $bdf91181004cdb95$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    if ((0, $dh538.fg)('enable_teams_t26_design_drop_core_experiences')) {
        const resolvedSrc = hasImageErrored ? (0, $asaw9.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            as: "img",
            src: resolvedSrc,
            alt: alt,
            testId: testId && `${testId}--image`,
            xcss: $bdf91181004cdb95$var$avatarImageStyles.image,
            onError: ()=>setHasImageErrored(true)
        });
    }
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $gMc0m.default)([
            $bdf91181004cdb95$var$unboundStyles.root,
            $bdf91181004cdb95$var$containerStyles.root,
            $bdf91181004cdb95$var$borderRadiusMap[size],
            $bdf91181004cdb95$var$widthHeightMap[size],
            compact ? $bdf91181004cdb95$var$containerStyles.compactSpacing : $bdf91181004cdb95$var$containerStyles.nonCompactSpacing
        ])
    }, /*#__PURE__*/ $42omo.createElement("img", {
        src: avatarSrc,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        className: (0, $gMc0m.default)([
            $bdf91181004cdb95$var$avatarImageStyles.image
        ])
    }));
};
module.exports["TeamAvatarImage"] = $bdf91181004cdb95$export$ac3673635a5387be;

});

parcelRegister("5P3yi", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $2cfa1b514c8db58a$var$styles = {
    wrapperOld: "_1e0c1txw",
    wrapper: "_1reo15vq _18m915vq _2rkol0p1 _1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
const $2cfa1b514c8db58a$export$eb63dcc490f6bbcd = (0, $4pOgL.isReactCompilerActivePlatform)() ? function FallbackAvatar(t0) {
    const $ = (0, $frIzR.c)(13);
    let compact;
    let props;
    if ($[0] !== t0) {
        ({ compact: compact, ...props } = t0);
        $[0] = t0;
        $[1] = compact;
        $[2] = props;
    } else {
        compact = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $dh538.fg)("yurree_jjj_3_ads_fixes") ? $2cfa1b514c8db58a$var$styles.wrapper : $2cfa1b514c8db58a$var$styles.wrapperOld;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = compact ? $2cfa1b514c8db58a$var$styles.compactWrapperSpacing : $2cfa1b514c8db58a$var$styles.wrapperSpacing;
    let t3;
    if ($[4] !== t2) {
        t3 = (0, $1Whri.cx)(t1, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2032_552)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "32",
            height: "32",
            rx: "4",
            fill: "#DCDFE4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
            fill: "#44546F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
            fill: "#44546F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
            fill: "#44546F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
            fill: "#44546F"
        }));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2032_552"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "32",
            height: "32",
            rx: "4",
            fill: "white"
        })));
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== props) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, t4, t5);
        $[8] = props;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t3 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t3
        }, t6);
        $[10] = t3;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FallbackAvatar({ compact: compact, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)((0, $dh538.fg)('yurree_jjj_3_ads_fixes') ? $2cfa1b514c8db58a$var$styles.wrapper : $2cfa1b514c8db58a$var$styles.wrapperOld, compact ? $2cfa1b514c8db58a$var$styles.compactWrapperSpacing : $2cfa1b514c8db58a$var$styles.wrapperSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2032_552)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "4",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
        fill: "#44546F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2032_552"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "4",
        fill: "white"
    })))));
};
module.exports["FallbackAvatar"] = $2cfa1b514c8db58a$export$eb63dcc490f6bbcd;

});

parcelRegister("asaw9", function(module, exports) {
const $173e925e8d2d7463$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;
module.exports["TEAM_FALLBACK_AVATAR_DATA_URI"] = $173e925e8d2d7463$export$215bd25cfab1a96;

});

parcelRegister("f2BEc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $asaw9 = parcelRequire("asaw9");

function $e75bf44959780d0d$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return (0, $dh538.fg)('enable_teams_t26_design_drop_core_experiences') ? (0, $asaw9.TEAM_FALLBACK_AVATAR_DATA_URI) : undefined;
}
module.exports["getTeamAvatarSrc"] = $e75bf44959780d0d$export$59ff7d19feb890b6;

});

parcelRegister("5kTPO", function(module, exports) {

var $74ZOc = parcelRequire("74ZOc");


var $g2dtt = parcelRequire("g2dtt");

const $fb7b59d200301a0e$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $g2dtt.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                ...request.verifiedTeams === true && {
                    isVerifiedTeamFilter: true
                },
                ...request.isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                },
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: request.restrictTo || {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $74ZOc.transformUsers)(response, intl));
};
var $fb7b59d200301a0e$export$2e2bcd8739ae039 = $fb7b59d200301a0e$var$getUserRecommendations;
module.exports["default"] = $fb7b59d200301a0e$export$2e2bcd8739ae039;

});

parcelRegister("74ZOc", function(module, exports) {

var $RMvle = parcelRequire("RMvle");


var $bicYK = parcelRequire("bicYK");


var $b4tkb = parcelRequire("b4tkb");


var $dh538 = parcelRequire("dh538");

const $465f7c420800703a$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $bicYK.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $b4tkb.EntityType).GROUP ? (0, $bicYK.messages).guestGroupLozengeTooltip : (0, $bicYK.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $bicYK.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    const isJiraGuestUser = (0, $dh538.fg)('user_picker_guest_lozenges') && entity.attributes?.isJiraGuest;
    if (isJiraGuestUser) return intl.formatMessage((0, $bicYK.messages).guestLozengeText);
    return undefined;
};
const $465f7c420800703a$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $b4tkb.EntityType).USER) {
        const user = item;
        const lozenge = $465f7c420800703a$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $RMvle.ExternalUserType) : (0, $RMvle.UserType),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined,
            appType: user.appType !== undefined ? user.appType : user.attributes?.appType
        };
    }
    if (type === (0, $b4tkb.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $RMvle.TeamType),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified,
            teamTypeName: team.type?.name,
            state: team.state
        };
    }
    if (type === (0, $b4tkb.EntityType).GROUP) {
        const group = item;
        const lozenge = $465f7c420800703a$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $RMvle.GroupType),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $465f7c420800703a$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$465f7c420800703a$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
module.exports["transformUsers"] = $465f7c420800703a$export$fb8c90bfc4beaa59;

});

parcelRegister("RMvle", function(module, exports) {
const $9aa1f267f5b06881$export$8436e53e45ffe15b = 'user';
const $9aa1f267f5b06881$export$50042ec1d2e00e63 = 'external_user';
const $9aa1f267f5b06881$export$26bc40b960693765 = 'team';
const $9aa1f267f5b06881$export$d460f747b73abb10 = 'group';
const $9aa1f267f5b06881$export$6662b3461398ef8c = 'email';
const $9aa1f267f5b06881$export$eafd0979afa5b224 = 'custom';
module.exports["UserType"] = $9aa1f267f5b06881$export$8436e53e45ffe15b;
module.exports["ExternalUserType"] = $9aa1f267f5b06881$export$50042ec1d2e00e63;
module.exports["TeamType"] = $9aa1f267f5b06881$export$26bc40b960693765;
module.exports["GroupType"] = $9aa1f267f5b06881$export$d460f747b73abb10;
module.exports["EmailType"] = $9aa1f267f5b06881$export$6662b3461398ef8c;
module.exports["CustomType"] = $9aa1f267f5b06881$export$eafd0979afa5b224;

});

parcelRegister("bicYK", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5083ba0e2c523183$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
module.exports["messages"] = $5083ba0e2c523183$export$defe85febe8b728c;

});

parcelRegister("b4tkb", function(module, exports) {
var $bc15afc2f3227082$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $bc15afc2f3227082$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});
module.exports["EntityType"] = $bc15afc2f3227082$export$8eda7e02f8f033b2;
module.exports["UserEntityType"] = $bc15afc2f3227082$export$ef0ef29634e52a6b;

});

parcelRegister("g2dtt", function(module, exports) {
const $bdd893fcacf86342$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};
module.exports["config"] = $bdd893fcacf86342$export$e506a1d27d1eaa20;

});

parcelRegister("kSKAi", function(module, exports) {
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1DWH0 = parcelRequire("1DWH0");


var $99qsA = parcelRequire("99qsA");

var $6T8v4 = parcelRequire("6T8v4");


var $28cxD = parcelRequire("28cxD");


var $42omo = parcelRequire("42omo");


var $89I2S = parcelRequire("89I2S");


var $lugM7 = parcelRequire("lugM7");


var $e1cJ5 = parcelRequire("e1cJ5");


var $dTofT = parcelRequire("dTofT");


var $bYlb2 = parcelRequire("bYlb2");


var $39zOH = parcelRequire("39zOH");


var $aahZc = parcelRequire("aahZc");


var $8hAFq = parcelRequire("8hAFq");


var $dQl1W = parcelRequire("dQl1W");


var $dh538 = parcelRequire("dh538");

function $f70d9dc6cc3ace22$var$_defineProperty(e, r, t) {
    return (r = $f70d9dc6cc3ace22$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f70d9dc6cc3ace22$var$_toPropertyKey(t) {
    var i = $f70d9dc6cc3ace22$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f70d9dc6cc3ace22$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $f70d9dc6cc3ace22$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const experienceForId = (0, $8hAFq.userPickerRenderedUfoExperience).getInstance(this.ufoId); // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
            (0, $28cxD.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $99qsA.default) : (0, $6T8v4.default);
        const creatableProps = suggestEmailsForDomain ? (0, $bYlb2.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $dTofT.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hAFq.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39zOH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aahZc.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $89I2S.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            forwardedRef: this.props.forwardedRef,
            width: width,
            SelectComponent: SelectComponent,
            styles: (0, $lugM7.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $dh538.fg)('platform-component-visual-refresh'), false, this.props.height, this.props.minHeight),
            components: (0, $e1cJ5.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
            pickerProps: pickerProps
        }))));
    }
    constructor(props){
        super(props); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        $f70d9dc6cc3ace22$var$_defineProperty(this, "ufoId", void 0);
        this.ufoId = (0, $dQl1W.v4)();
        const experienceForId = (0, $8hAFq.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
            (0, $28cxD.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
}
$f70d9dc6cc3ace22$var$_defineProperty($f70d9dc6cc3ace22$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $f70d9dc6cc3ace22$export$83e0c73b09b3a9cd = (0, $1DWH0.default)()($f70d9dc6cc3ace22$export$164f4d95e5d7e2f5);
module.exports["UserPicker"] = $f70d9dc6cc3ace22$export$83e0c73b09b3a9cd;

});

parcelRegister("89I2S", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $jSnXV = parcelRequire("jSnXV");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dQl1W = parcelRequire("dQl1W");


var $dlhVH = parcelRequire("dlhVH");


var $chpH1 = parcelRequire("chpH1");


var $3aPpx = parcelRequire("3aPpx");


var $6O3OC = parcelRequire("6O3OC");


var $8UAzT = parcelRequire("8UAzT");


var $8hAFq = parcelRequire("8hAFq");

const $c504d7760af5313e$var$loadingMessage = ()=>null;
const $c504d7760af5313e$var$classNamePrefix = 'fabric-user-picker';
class $c504d7760af5313e$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $6O3OC.optionToSelectableOptions)(nextProps.value);
        else if ((0, $6O3OC.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $6O3OC.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused or isHeaderFocused changes from true to false
        if (menuIsOpen && (prevProps.isFooterFocused === true && this.props.isFooterFocused === false || prevProps.isHeaderFocused === true && this.props.isHeaderFocused === false) && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $6O3OC.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $dlhVH.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $dlhVH.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $28cxD.UFOExperienceState).STARTED.id,
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: this.props.openMenuOnFocus ?? true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $c504d7760af5313e$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).placeholder),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $c504d7760af5313e$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
    constructor(props){
        super(props);
        this.selectRef = void 0;
        this.session = void 0;
        // session id for focus to blur
        this.journeyId = void 0;
        this.optionsShownUfoExperienceInstance = void 0;
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $6O3OC.callCallback)(onChange, (0, $6O3OC.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $6O3OC.callCallback)(onSelection, (0, $6O3OC.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $dlhVH.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $dlhVH.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $6O3OC.callCallback)(onClear);
                    this.fireEvent((0, $dlhVH.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $dlhVH.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $dlhVH.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $chpH1.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $dlhVH.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $6O3OC.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $28cxD.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $6O3OC.callCallback)(this.props.onFocus, this.getSessionId());
            const openMenuOnFocus = this.props.openMenuOnFocus ?? true;
            if (!this.isMenuOpenOnClickForSingleSelect && openMenuOnFocus) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $6O3OC.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $6O3OC.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleOpen = ()=>{
            (0, $6O3OC.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleBlur = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            (0, $6O3OC.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $6O3OC.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleClose = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            this.resetInputState();
            (0, $6O3OC.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $6O3OC.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $dlhVH.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $dlhVH.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $dlhVH.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (event.key === 'Escape') {
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
                this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                this.props.setIsHeaderFocused && this.props.setIsHeaderFocused(false);
            }
            if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            if (event.key === 'Tab' && this.props.setIsHeaderFocused && this.props.header) this.props.setIsHeaderFocused(true);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptionsOld = ()=>{
            const options = (0, $6O3OC.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(options, groupByTypeOrder) : options;
        };
        this.getOptionsNew = ()=>{
            const options = (0, $6O3OC.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder, customGroupLabels: customGroupLabels } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder, customGroupLabels) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(options, groupByTypeOrder, customGroupLabels) : options;
        };
        this.getOptions = ()=>{
            return (0, $dh538.fg)('jsm-wfo-assignee-recommendation-on-queues') ? this.getOptionsNew() : this.getOptionsOld();
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused) || Boolean(!!this.props.header) && Boolean(this.props.isHeaderFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $8hAFq.userPickerOptionsShownUfoExperience).getInstance((0, $dQl1W.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
}
$c504d7760af5313e$export$b4ff48c8d43b18c3.defaultProps = {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).errorMessage),
    openMenuOnClick: false
};
const $c504d7760af5313e$export$d099ade7b4f4d2a4 = (0, $1DWH0.default)()($c504d7760af5313e$export$b4ff48c8d43b18c3);
module.exports["BaseUserPickerWithoutAnalytics"] = $c504d7760af5313e$export$b4ff48c8d43b18c3;

});

parcelRegister("dlhVH", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $eWRwJ = parcelRequire("eWRwJ");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $dQl1W = parcelRequire("dQl1W");


var $6O3OC = parcelRequire("6O3OC");

const $02b4d9c4beeba836$var$packageName = "platform-pkg";
const $02b4d9c4beeba836$var$packageVersion = "0.0.0-use.local";
const $02b4d9c4beeba836$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $02b4d9c4beeba836$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $02b4d9c4beeba836$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $02b4d9c4beeba836$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $dQl1W.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $02b4d9c4beeba836$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $02b4d9c4beeba836$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $02b4d9c4beeba836$var$packageName,
            packageVersion: $02b4d9c4beeba836$var$packageVersion,
            ...attributes
        }
    });
const $02b4d9c4beeba836$var$checkValidId = (id)=>{
    return $02b4d9c4beeba836$var$UUID_REGEXP_NEW_AAID.test(id) || $02b4d9c4beeba836$var$UUID_REGEXP_OLD_AAID.test(id) || $02b4d9c4beeba836$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $02b4d9c4beeba836$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $02b4d9c4beeba836$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $6O3OC.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $6O3OC.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $02b4d9c4beeba836$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$02b4d9c4beeba836$var$optionData2Analytics(data));
    }
    return [];
};
const $02b4d9c4beeba836$var$selectedCustomGroupAnalyticsAttributes = (props, option)=>{
    if (!props.customGroupLabels) return {};
    const selectedType = option?.data.type;
    const analyticsLabel = selectedType ? props.customGroupAnalyticsLabels?.[selectedType] : undefined;
    return {
        hasCustomGroupLabels: true,
        ...analyticsLabel ? {
            selectedLabel: analyticsLabel
        } : {}
    };
};
const $02b4d9c4beeba836$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $02b4d9c4beeba836$var$sessionId(session),
        pickerType: $02b4d9c4beeba836$var$pickerType(props),
        journeyId: journeyId
    });
const $02b4d9c4beeba836$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('ui', 'focused', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $02b4d9c4beeba836$var$buildValueForAnalytics(state.value)
    });
const $02b4d9c4beeba836$export$7b5800e732182efb = (props, state, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $02b4d9c4beeba836$var$values(state)
    });
const $02b4d9c4beeba836$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$02b4d9c4beeba836$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $02b4d9c4beeba836$var$sessionId(session),
        journeyId: journeyId,
        value: $02b4d9c4beeba836$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen,
        ...(0, $c6GJD.default).getExperimentValue('team_member_suggestions_while_creating_team', 'isEnabled', false) && args[0]?.isSuggestedMember !== undefined ? {
            isSuggestedMember: args[0].isSuggestedMember
        } : {}
    });
const $02b4d9c4beeba836$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$02b4d9c4beeba836$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        queryLength: $02b4d9c4beeba836$var$queryLength(args[0]),
        spaceInQuery: $02b4d9c4beeba836$var$spaceInQuery(args[0]),
        upKeyCount: $02b4d9c4beeba836$var$upKeyCount(session),
        downKeyCount: $02b4d9c4beeba836$var$downKeyCount(session)
    });
const $02b4d9c4beeba836$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $02b4d9c4beeba836$var$createEvent('ui', $02b4d9c4beeba836$var$selectEventType(session), 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        position: $02b4d9c4beeba836$var$position(state, args[0]),
        queryLength: $02b4d9c4beeba836$var$queryLength(state),
        spaceInQuery: $02b4d9c4beeba836$var$spaceInQuery(state),
        upKeyCount: $02b4d9c4beeba836$var$upKeyCount(session),
        downKeyCount: $02b4d9c4beeba836$var$downKeyCount(session),
        result: $02b4d9c4beeba836$var$result(args[0]),
        numberOfResults: $02b4d9c4beeba836$var$numberOfResults(state),
        ...(0, $dh538.fg)('jsm_routing_recommended_agent_minor_fix') ? $02b4d9c4beeba836$var$selectedCustomGroupAnalyticsAttributes(props, args[0]) : {}
    });
};
const $02b4d9c4beeba836$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $02b4d9c4beeba836$var$results(state);
    return $02b4d9c4beeba836$var$createEvent('operational', 'searched', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        durationSinceInputChange: $02b4d9c4beeba836$var$durationSinceInputChange(session),
        queryLength: $02b4d9c4beeba836$var$queryLength(state),
        isLoading: $02b4d9c4beeba836$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $02b4d9c4beeba836$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('operational', 'failed', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $02b4d9c4beeba836$export$f541f04954b0c11e = (sources, accountId)=>$02b4d9c4beeba836$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $02b4d9c4beeba836$var$checkValidId(accountId) ? accountId : null
    });
function $02b4d9c4beeba836$var$queryLength(state) {
    return state.inputValue.length;
}
function $02b4d9c4beeba836$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $02b4d9c4beeba836$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $02b4d9c4beeba836$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $02b4d9c4beeba836$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $02b4d9c4beeba836$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $02b4d9c4beeba836$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $02b4d9c4beeba836$var$sessionId(session) {
    return session && session.id;
}
function $02b4d9c4beeba836$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $02b4d9c4beeba836$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $02b4d9c4beeba836$var$result(option) {
    return option ? $02b4d9c4beeba836$var$optionData2Analytics(option.data) : null;
}
function $02b4d9c4beeba836$var$results(state) {
    return (state.options || []).map($02b4d9c4beeba836$var$optionData2Analytics);
}
function $02b4d9c4beeba836$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $02b4d9c4beeba836$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$02b4d9c4beeba836$var$optionData2Analytics(option.data)) : [
        $02b4d9c4beeba836$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $02b4d9c4beeba836$var$numberOfResults(state) {
    return (state.options || []).length;
}
module.exports["startSession"] = $02b4d9c4beeba836$export$c0d84948cecf78d8;
module.exports["createAndFireEventInElementsChannel"] = $02b4d9c4beeba836$export$53eef0dcd9611650;
module.exports["focusEvent"] = $02b4d9c4beeba836$export$e7818c470f37c4bd;
module.exports["clearEvent"] = $02b4d9c4beeba836$export$7b5800e732182efb;
module.exports["deleteEvent"] = $02b4d9c4beeba836$export$95711ec6c6227e9a;
module.exports["cancelEvent"] = $02b4d9c4beeba836$export$e9caaaecfee38128;
module.exports["selectEvent"] = $02b4d9c4beeba836$export$48143d759475d90f;
module.exports["searchedEvent"] = $02b4d9c4beeba836$export$911fb7184b6037eb;
module.exports["failedEvent"] = $02b4d9c4beeba836$export$c2aec355fef65c9c;
module.exports["userInfoEvent"] = $02b4d9c4beeba836$export$f541f04954b0c11e;

});

parcelRegister("6O3OC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $6Ipjn = parcelRequire("6Ipjn");

const $e3824e6fb8890c7f$export$f6058dbcb5980cb = (option)=>option.type === (0, $RMvle.ExternalUserType) || Boolean(option.isExternal);
const $e3824e6fb8890c7f$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $RMvle.UserType);
const $e3824e6fb8890c7f$export$f8c4277cb588611f = (option)=>option?.type === (0, $RMvle.TeamType);
const $e3824e6fb8890c7f$export$d7976824e9f55785 = (option)=>option.type === (0, $RMvle.GroupType);
const $e3824e6fb8890c7f$export$7fbbfbca30081d0 = (option)=>option.type === (0, $RMvle.EmailType);
const $e3824e6fb8890c7f$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $RMvle.CustomType);
const $e3824e6fb8890c7f$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $e3824e6fb8890c7f$var$isOptionData = (option)=>option.name !== undefined;
const $e3824e6fb8890c7f$export$3f993c492bd6c728 = (option)=>{
    if ($e3824e6fb8890c7f$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $e3824e6fb8890c7f$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $e3824e6fb8890c7f$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $e3824e6fb8890c7f$export$d2312e68e1f5ad00 = (0, $2XqLN.default)((options)=>options.map($e3824e6fb8890c7f$export$3f993c492bd6c728));
const $e3824e6fb8890c7f$export$e6fda14a194bcbcc = (0, $2XqLN.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($e3824e6fb8890c7f$export$3f993c492bd6c728);
    return $e3824e6fb8890c7f$export$3f993c492bd6c728(defaultValue);
});
const $e3824e6fb8890c7f$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $e3824e6fb8890c7f$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $e3824e6fb8890c7f$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $e3824e6fb8890c7f$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $e3824e6fb8890c7f$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $e3824e6fb8890c7f$export$b4f8f1f54acec99b = (optionData)=>{
    if ($e3824e6fb8890c7f$export$2e44165f1da65304(optionData) || $e3824e6fb8890c7f$export$f8c4277cb588611f(optionData) || $e3824e6fb8890c7f$export$d3a8f0b77e9737fc(optionData) || $e3824e6fb8890c7f$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $e3824e6fb8890c7f$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $6Ipjn.default);
const $e3824e6fb8890c7f$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $e3824e6fb8890c7f$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};
module.exports["isExternalUser"] = $e3824e6fb8890c7f$export$f6058dbcb5980cb;
module.exports["isUser"] = $e3824e6fb8890c7f$export$2e44165f1da65304;
module.exports["isTeam"] = $e3824e6fb8890c7f$export$f8c4277cb588611f;
module.exports["isGroup"] = $e3824e6fb8890c7f$export$d7976824e9f55785;
module.exports["isEmail"] = $e3824e6fb8890c7f$export$7fbbfbca30081d0;
module.exports["isCustom"] = $e3824e6fb8890c7f$export$d3a8f0b77e9737fc;
module.exports["isDefaultValuePopulated"] = $e3824e6fb8890c7f$export$d6978985a41b0c8;
module.exports["extractOptionValue"] = $e3824e6fb8890c7f$export$7ae97131df521bff;
module.exports["isIterable"] = $e3824e6fb8890c7f$export$9652023d9040757;
module.exports["getOptions"] = $e3824e6fb8890c7f$export$d2312e68e1f5ad00;
module.exports["optionToSelectableOptions"] = $e3824e6fb8890c7f$export$e6fda14a194bcbcc;
module.exports["getAvatarSize"] = $e3824e6fb8890c7f$export$695fb564e621339a;
module.exports["isChildInput"] = $e3824e6fb8890c7f$export$3c62cf9a01367f27;
module.exports["isSingleValue"] = $e3824e6fb8890c7f$export$203c2bd2662d1ca2;
module.exports["hasValue"] = $e3824e6fb8890c7f$export$96bdbc84526f3739;
module.exports["callCallback"] = $e3824e6fb8890c7f$export$df325aa844b03c31;
module.exports["getAvatarUrl"] = $e3824e6fb8890c7f$export$b4f8f1f54acec99b;
module.exports["isPopupUserPickerByComponent"] = $e3824e6fb8890c7f$export$4f60a74234178416;
module.exports["isLozengeText"] = $e3824e6fb8890c7f$export$5419897287f5f1c7;

});

parcelRegister("chpH1", function(module, exports) {
function $f35c9d88e8abf7dd$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}
module.exports["batchByKey"] = $f35c9d88e8abf7dd$export$da86c38211c1c0a8;

});

parcelRegister("3aPpx", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $4f3ddb26b3e05986$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    placeholder: {
        id: "fabric.elements.user-picker.placeholder",
        defaultMessage: "Enter people or teams..."
    },
    addMore: {
        id: "fabric.elements.user-picker.placeholder.add-more",
        defaultMessage: "add more people..."
    },
    remove: {
        id: "fabric.elements.user-picker.multi.remove-item",
        defaultMessage: "Remove"
    },
    clear: {
        id: "fabric.elements.user-picker.single.clear",
        defaultMessage: "Clear"
    },
    errorMessage: {
        id: "fabric.elements.user-picker.error.message",
        defaultMessage: "Something went wrong"
    },
    teamByline: {
        id: "fabric.elements.user-picker.team.byline",
        defaultMessage: "Team"
    },
    officialTeamByline: {
        id: "fabric.elements.user-picker.team.byline.official",
        defaultMessage: "{teamTypeName} {verifiedIcon}"
    },
    officialMemberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}"
    },
    officialMemberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.including.you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    officialPlus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members"
    },
    officialPlus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    addEmail: {
        id: "fabric.elements.user-picker.email.add",
        defaultMessage: "Add user"
    },
    selectToAddEmail: {
        id: "fabric.elements.user-picker.email.select.to.add",
        defaultMessage: "Select an email address"
    },
    continueToAddEmail: {
        id: "fabric.elements.user-picker.email.add.potential",
        defaultMessage: "Enter an email address"
    },
    adminManagedGroupByline: {
        id: "fabric.elements.user-picker.group.byline.admin-managed",
        defaultMessage: "Admin group {verifiedIcon}"
    },
    groupByline: {
        id: "fabric.elements.user-picker.group.byline",
        defaultMessage: "Admin-managed group"
    },
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    externalUserSourcesError: {
        id: "fabric.elements.user-picker.external.sourced.error",
        defaultMessage: "We can't connect you right now."
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    jiraSource: {
        id: "fabric.elements.user-picker.source.jira",
        defaultMessage: "Jira"
    },
    confluenceSource: {
        id: "fabric.elements.user-picker.source.confluence",
        defaultMessage: "Confluence"
    },
    otherAtlassianSource: {
        id: "fabric.elements.user-picker.source.other-atlassian",
        defaultMessage: "Other Atlassian products"
    },
    otherAtlassianSourceAppify: {
        id: "fabric.elements.user-picker.source.other-atlassian-appify",
        defaultMessage: "Other Atlassian apps"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    },
    archivedLozenge: {
        id: "fabric.elements.user-picker.archived.lozenge.text",
        defaultMessage: "Archived"
    },
    userTypeLabel: {
        id: "fabric.elements.user-picker.user.type.label",
        defaultMessage: "People"
    },
    teamTypeLabel: {
        id: "fabric.elements.user-picker.team.type.label",
        defaultMessage: "Teams"
    },
    emailTypeLabel: {
        id: "fabric.elements.user-picker.email.type.label",
        defaultMessage: "Emails"
    },
    groupTypeLabel: {
        id: "fabric.elements.user-picker.group.type.label",
        defaultMessage: "Groups"
    },
    externalUserTypeLabel: {
        id: "fabric.elements.user-picker.external.user.type.label",
        defaultMessage: "External Users"
    },
    customTypeLabel: {
        id: "fabric.elements.user-picker.custom.type.label",
        defaultMessage: "Customs"
    },
    otherTypeLabel: {
        id: "fabric.elements.user-picker.other.type.label",
        defaultMessage: "Others"
    }
});
module.exports["messages"] = $4f3ddb26b3e05986$export$defe85febe8b728c;

});

parcelRegister("8UAzT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $aXWIB = parcelRequire("aXWIB");


var $2XqLN = parcelRequire("2XqLN");


var $3aPpx = parcelRequire("3aPpx");

const $ca249474c88b0d42$var$getLabelForType = (type, customLabels)=>{
    if (customLabels && type in customLabels && (0, $dh538.fg)('jsm-wfo-assignee-recommendation-on-queues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, customLabels[type]);
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).userTypeLabel);
        case 'team':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).teamTypeLabel);
        case 'group':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).groupTypeLabel);
        case 'custom':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).customTypeLabel);
        case 'external_user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).externalUserTypeLabel);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).otherTypeLabel);
    }
};
const $ca249474c88b0d42$export$393a985f7dd07cfe = (0, $2XqLN.default)((options, groupByTypeOrder, customGroupLabels)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $ca249474c88b0d42$var$getLabelForType(type, customGroupLabels),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});
module.exports["groupOptionsByType"] = $ca249474c88b0d42$export$393a985f7dd07cfe;

});

parcelRegister("8hAFq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $28cxD = parcelRequire("28cxD");

const $6d031c0252e61ff0$export$b49757166e1acfc2 = new (0, $9801n.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
const $6d031c0252e61ff0$export$135a264e0da507ae = new (0, $9801n.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $iqaft.ExperienceTypes).Operation,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
});
class $6d031c0252e61ff0$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        const instance = $6d031c0252e61ff0$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $28cxD.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["userPickerRenderedUfoExperience"] = $6d031c0252e61ff0$export$b49757166e1acfc2;
module.exports["userPickerOptionsShownUfoExperience"] = $6d031c0252e61ff0$export$135a264e0da507ae;
module.exports["UfoErrorBoundary"] = $6d031c0252e61ff0$export$5ef1c2550074a375;

});

parcelRegister("lugM7", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $eKXGE = parcelRequire("eKXGE");


var $2XqLN = parcelRequire("2XqLN");

const $4ce04523015976a9$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $4ce04523015976a9$export$53937c04f7dfc2ae = 6;
const $4ce04523015976a9$export$2c62ba763e976c54 = 39;
const $4ce04523015976a9$export$ffd58b7f6f099a57 = (0, $2XqLN.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height, minHeight)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : state.selectProps.subtle ? 'transparent' : state.isDisabled && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-background-disabled, #0515240F)" : state.selectProps.textFieldBackgroundColor ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)",
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? "var(--ds-background-danger, #FFECEB)" : state.isFocused ? css[':hover'] ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)" : state.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-background-input-hovered, #F8F8F8)"
                },
                padding: 0,
                minHeight: minHeight ? minHeight : height || isCompact ? isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 30 : 'none' : isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 42 : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _paddingLeft: _paddingLeft, _paddingRight: _paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _position: _position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ce04523015976a9$export$59c188914e58c94b,
                paddingBottom: isCompact ? isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ce04523015976a9$export$59c188914e58c94b,
                // Match pre–tag-uplift leading inset when only the placeholder shows (share dialog VR, etc.).
                paddingLeft: isMulti ? state.hasValue && state.selectProps.controlShouldRenderValue !== false && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ce04523015976a9$export$59c188914e58c94b : 0,
                gap: isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-050, 4px)" : undefined,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$4ce04523015976a9$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 0 : `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                ...isMulti && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && {
                    height: "var(--ds-space-250, 20px)",
                    alignItems: 'center'
                },
                paddingLeft: state.selectProps.isMulti ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: "var(--ds-text-subtlest, #6B6E76)",
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: "var(--ds-text-subtlest, #6B6E76)"
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $eKXGE.mergeStyles)(styles, overrideStyles) : styles;
});
const $4ce04523015976a9$export$4e983f376ad8a3af = (0, $2XqLN.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$4ce04523015976a9$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));
module.exports["getStyles"] = $4ce04523015976a9$export$ffd58b7f6f099a57;

});

parcelRegister("e1cJ5", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $8BxoE = parcelRequire("8BxoE");


var $8Z5lp = parcelRequire("8Z5lp");


var $djtLL = parcelRequire("djtLL");


var $d1LXW = parcelRequire("d1LXW");


var $biJXh = parcelRequire("biJXh");


var $gtKKr = parcelRequire("gtKKr");


var $95uM8 = parcelRequire("95uM8");


var $aoWT3 = parcelRequire("aoWT3");


var $91jwt = parcelRequire("91jwt");


var $8lAE4 = parcelRequire("8lAE4");


var $8LA5n = parcelRequire("8LA5n");

const $55820c8d7312f5f6$export$4e811121b221213b = (0, $2XqLN.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $d1LXW.Option
    };
    else return {
        MultiValue: $8Z5lp.MultiValue,
        DropdownIndicator: null,
        SingleValue: $biJXh.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $8BxoE.ClearIndicator) : null,
        Option: $d1LXW.Option,
        ValueContainer: multi ? (0, $djtLL.MultiValueContainer) : (0, $95uM8.SingleValueContainer),
        Input: $gtKKr.Input,
        Menu: $8lAE4.Menu,
        Control: $8LA5n.default,
        ...customComponents ? customComponents : {}
    };
});
const $55820c8d7312f5f6$export$19205fd341a6bb08 = (0, $2XqLN.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $biJXh.SingleValue,
        ClearIndicator: $8BxoE.ClearIndicator,
        Option: $d1LXW.Option,
        ValueContainer: (0, $95uM8.SingleValueContainer),
        Input: (0, $aoWT3.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $91jwt.PopupControl)
    };
    return baseProps;
});
module.exports["getComponents"] = $55820c8d7312f5f6$export$4e811121b221213b;

});

parcelRegister("8BxoE", function(module, exports) {
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

function $a971b05a8af6e488$var$_defineProperty(e, r, t) {
    return (r = $a971b05a8af6e488$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a971b05a8af6e488$var$_toPropertyKey(t) {
    var i = $a971b05a8af6e488$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a971b05a8af6e488$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

const $a971b05a8af6e488$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $a971b05a8af6e488$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $a971b05a8af6e488$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $a971b05a8af6e488$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a971b05a8af6e488$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        $a971b05a8af6e488$var$_defineProperty(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
             // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue(); //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
}
module.exports["ClearIndicator"] = $a971b05a8af6e488$export$ecf9cf59142dd54a;

});

parcelRegister("dWRcP", function(module, exports) {

let $a279f6b565ca3fab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a279f6b565ca3fab$var$load("764nc").then(()=>parcelRequire('SMbnh'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("8Z5lp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");


var $9K4OG = parcelRequire("9K4OG");


var $esRft = parcelRequire("esRft");


var $dh538 = parcelRequire("dh538");


var $7aL0g = parcelRequire("7aL0g");

var $3WVxj = parcelRequire("3WVxj");


var $alaek = parcelRequire("alaek");


var $7NrQn = parcelRequire("7NrQn");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $5nBzc = parcelRequire("5nBzc");


var $lebfc = parcelRequire("lebfc");


var $cO3Oi = parcelRequire("cO3Oi");


var $aXWIB = parcelRequire("aXWIB");


var $3aPpx = parcelRequire("3aPpx");

function $926971438bfd3fb0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $926971438bfd3fb0$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $926971438bfd3fb0$var$groupTagContainerOld = (0, $ecnYn.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $926971438bfd3fb0$var$groupTagContainer = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $926971438bfd3fb0$var$archivedLozengeWrapper = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingLeft: 'space.050'
});
const $926971438bfd3fb0$var$iconStyle = {
    name: "1sq8lny",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:20px;height:20px"
};
const $926971438bfd3fb0$var$nameWrapper = {
    name: "1b3uxdh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
const $926971438bfd3fb0$var$avatarTagWrapperStyle = {
    name: "14413o7",
    styles: "display:flex;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
class $926971438bfd3fb0$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $926971438bfd3fb0$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: option, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: nextOption, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        if (option == null || nextOption == null) return option !== nextOption || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        const { label: label, data: data } = option;
        const { label: nextLabel, data: nextData } = nextOption;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: _innerProps, removeProps: removeProps, data: option, ...rest } = this.props;
        if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const { data: data, label: label } = option;
            const isTeamOption = (0, $6O3OC.isTeam)(data);
            const isGroupOption = (0, $6O3OC.isGroup)(data);
            const isEmailOption = (0, $6O3OC.isEmail)(data);
            const avatarUrl = (0, $6O3OC.getAvatarUrl)(data);
            const isDisabled = Boolean(this.props.selectProps?.isDisabled);
            const canShowArchivedLozenge = (0, $6O3OC.isTeam)(data) && data?.state === 'DISBANDED' && (0, $dh538.fg)('enable-sup-archive-experience');
            const avatarProps = avatarUrl ? {
                name: data.name,
                src: avatarUrl
            } : {
                name: data.name
            };
            const onAfterRemoveAction = ()=>{
                removeProps.onClick({});
            };
            if (isEmailOption) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                ref: this.containerRef,
                css: $926971438bfd3fb0$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3WVxj.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7NrQn.AddOptionAvatar), {
                    isLozenge: true,
                    isPendingAction: data.isPendingAction
                }),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (isGroupOption) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                ref: this.containerRef,
                css: $926971438bfd3fb0$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3WVxj.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $926971438bfd3fb0$var$groupTagContainer
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (data.icon) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                ref: this.containerRef,
                css: $926971438bfd3fb0$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3WVxj.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: $926971438bfd3fb0$var$iconStyle,
                    style: {
                        color: data.iconColor
                    }
                }, data.icon),
                isRemovable: !isDisabled,
                hasMargin: false,
                onAfterRemoveAction: onAfterRemoveAction
            }));
            return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                ref: this.containerRef,
                css: $926971438bfd3fb0$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, isTeamOption ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7aL0g.default), {
                type: "other",
                text: label,
                isVerified: isTeamOption ? data.verified : undefined,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $alaek.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }), canShowArchivedLozenge ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $926971438bfd3fb0$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), {
                appearance: "default"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).archivedLozenge))) : null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7aL0g.default), {
                type: "user",
                text: label,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $esRft.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }));
        }
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hOY6.components).MultiValue, {
            ...rest,
            data: option,
            removeProps: removeProps,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dcJ7R.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $926971438bfd3fb0$var$nameWrapper
        }, children), this.getElemAfter()));
    }
    constructor(props){
        super(props);
        this.containerRef = void 0;
        this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $6O3OC.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7NrQn.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $6O3OC.isGroup)(data)) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $926971438bfd3fb0$var$groupTagContainerOld
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                color: "currentColor",
                label: ""
            }));
            if (data.icon) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gElw0.AvatarOrIcon), {
                appearance: "multi",
                icon: data.icon,
                iconColor: data.iconColor,
                src: (0, $6O3OC.getAvatarUrl)(data),
                type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person'
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: "multi",
                src: (0, $6O3OC.getAvatarUrl)(data),
                type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person'
            });
        };
        this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            const canShowArchivedLozenge = (0, $6O3OC.isTeam)(data) && data?.state === 'DISBANDED' && (0, $dh538.fg)('enable-sup-archive-experience');
            if ((0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates || (0, $6O3OC.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            if (canShowArchivedLozenge) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $926971438bfd3fb0$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), {
                appearance: "default"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).archivedLozenge)));
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
module.exports["MultiValue"] = $926971438bfd3fb0$export$419cdf50db8b579;

});

parcelRegister("7NrQn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ldfch = parcelRequire("ldfch");


var $9K4OG = parcelRequire("9K4OG");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $1a863c2fdda060de$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF5DB)" : "var(--ds-background-neutral, #0515240F)";
    return /*#__PURE__*/ (0, $9K4OG.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $1a863c2fdda060de$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $1a863c2fdda060de$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        color: isPendingAction && (0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #9E4C00)" : "var(--ds-text-subtle, #505258)"
    })));
};
module.exports["AddOptionAvatar"] = $1a863c2fdda060de$export$df396db45e491922;

});

parcelRegister("gElw0", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $9K4OG = parcelRequire("9K4OG");

function $063475195e4c8312$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $063475195e4c8312$var$iconStyle = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $063475195e4c8312$var$iconSizes = {
    xsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    small: {
        name: "1c76jn8",
        styles: "width:28px;height:28px"
    },
    medium: {
        name: "bgbjt4",
        styles: "width:36px;height:36px"
    }
};
const $063475195e4c8312$export$60751fd23180a0ed = ({ appearance: appearance = 'big', avatarAppearanceShape: avatarAppearanceShape, icon: icon, iconColor: iconColor, presence: presence, src: src, type: type = 'person' })=>{
    // If icon is provided, render it instead of avatar
    if (icon) {
        const avatarSize = (0, $6O3OC.getAvatarSize)(appearance);
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                $063475195e4c8312$var$iconStyle,
                $063475195e4c8312$var$iconSizes[avatarSize]
            ],
            style: {
                color: iconColor
            }
        }, icon);
    }
    // Otherwise, render the avatar as before
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
        appearance: appearance,
        src: src,
        presence: presence,
        type: type,
        avatarAppearanceShape: avatarAppearanceShape
    });
};
module.exports["AvatarOrIcon"] = $063475195e4c8312$export$60751fd23180a0ed;

});

parcelRegister("daWcu", function(module, exports) {

var $esRft = parcelRequire("esRft");


var $alaek = parcelRequire("alaek");


var $42omo = parcelRequire("42omo");


var $6O3OC = parcelRequire("6O3OC");

class $7c01c0d05ab0848d$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $6O3OC.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $alaek.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), props);
    }
}
module.exports["SizeableAvatar"] = $7c01c0d05ab0848d$export$44d81a88129649da;

});

parcelRegister("cO3Oi", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bh5s2 = parcelRequire("bh5s2");


var $3gadb = parcelRequire("3gadb");


var $fk7e8 = parcelRequire("fk7e8");

const $5c856781f75583e4$export$d7949f68d31e5edd = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { label: t1, showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: t2, spacing: t3 } = t0;
    const label = t1 === undefined ? "Verified Team" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const spacing = t3 === undefined ? "spacious" : t3;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t4;
    if ($[0] !== customTooltipContent || $[1] !== formatMessage || $[2] !== showTooltip) {
        t4 = showTooltip ? customTooltipContent || formatMessage((0, $fk7e8.messages).verifiedIconDefaultTooltip) : undefined;
        $[0] = customTooltipContent;
        $[1] = formatMessage;
        $[2] = showTooltip;
        $[3] = t4;
    } else t4 = $[3];
    const tooltipContent = t4;
    let t5;
    if ($[4] !== label || $[5] !== size || $[6] !== spacing || $[7] !== tooltipContent) {
        t5 = tooltipContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon"
        }, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            size: size,
            label: tooltipContent,
            spacing: spacing
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            size: size,
            spacing: spacing,
            label: label
        });
        $[4] = label;
        $[5] = size;
        $[6] = spacing;
        $[7] = tooltipContent;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $fk7e8.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        tabIndex: 0,
        role: "button",
        "data-testid": "verified-team-icon"
    }, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        label: tooltipContent,
        spacing: spacing
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
module.exports["VerifiedTeamIcon"] = $5c856781f75583e4$export$d7949f68d31e5edd;

});

parcelRegister("fk7e8", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $81eb31bb2f17e3e1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: "ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip",
        defaultMessage: "This team is verified because it can only be changed by admin."
    }
});
module.exports["messages"] = $81eb31bb2f17e3e1$export$defe85febe8b728c;

});

parcelRegister("djtLL", function(module, exports) {
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $3hOY6 = parcelRequire("3hOY6");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $3aPpx = parcelRequire("3aPpx");


var $6O3OC = parcelRequire("6O3OC");


var $5zTZv = parcelRequire("5zTZv");


var $1bHXt = parcelRequire("1bHXt");

function $583428e46a5d063b$var$_defineProperty(e, r, t) {
    return (r = $583428e46a5d063b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $583428e46a5d063b$var$_toPropertyKey(t) {
    var i = $583428e46a5d063b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $583428e46a5d063b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $583428e46a5d063b$var$valueContainerStyles = {
    root: "_yv0e5bpd _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf",
    paddingLegacy: "_ca0qu2gc _n3tdu2gc _19bvu2gc",
    tagUpliftVerticalDefault: "_ca0qu2gc _n3tdu2gc",
    tagUpliftVerticalCompact: "_ca0qv77o _n3tdv77o",
    paddingLeftTight: "_19bv12x7",
    paddingLeftWide: "_19bvu2gc",
    withFlexAndGap: "_zulp1b66 _yv0en7od _1n261g80"
};
class $583428e46a5d063b$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: _children, innerProps: _innerProps, hasValue: hasValue, isCompact: isCompact, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            hasValue: hasValue,
            isCompact: isCompact,
            innerProps: this.valueContainerInnerProps
        };
        const ffTagUplifts = (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
        const controlRendersValueInControl = this.props.selectProps.controlShouldRenderValue !== false;
        const tagUpliftChipRow = ffTagUplifts && hasValue && controlRendersValueInControl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5zTZv.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).ValueContainer, {
            ...props,
            xcss: (0, $1bHXt.cx)($583428e46a5d063b$var$valueContainerStyles.root, !ffTagUplifts && $583428e46a5d063b$var$valueContainerStyles.paddingLegacy, ffTagUplifts && (isCompact ? $583428e46a5d063b$var$valueContainerStyles.tagUpliftVerticalCompact : $583428e46a5d063b$var$valueContainerStyles.tagUpliftVerticalDefault), ffTagUplifts && (tagUpliftChipRow ? $583428e46a5d063b$var$valueContainerStyles.paddingLeftWide : $583428e46a5d063b$var$valueContainerStyles.paddingLeftTight), tagUpliftChipRow && $583428e46a5d063b$var$valueContainerStyles.withFlexAndGap)
        }, this.renderChildren()));
    }
    constructor(props){
        super(props);
        $583428e46a5d063b$var$_defineProperty(this, "valueContainerInnerProps", void 0);
        $583428e46a5d063b$var$_defineProperty(this, "timeoutId", null);
        $583428e46a5d063b$var$_defineProperty(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        });
        $583428e46a5d063b$var$_defineProperty(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        $583428e46a5d063b$var$_defineProperty(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(this.props.children, (child)=>(0, $6O3OC.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        });
        $583428e46a5d063b$var$_defineProperty(this, "renderChildren", ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props; // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        }); //@ts-ignore react-select unsupported props
        $583428e46a5d063b$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef()
        };
    }
}
module.exports["MultiValueContainer"] = $583428e46a5d063b$export$cf9cf2a30a59265c;

});

parcelRegister("5zTZv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

function $e7cd9ff8a2bfdfe9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $e7cd9ff8a2bfdfe9$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $e7cd9ff8a2bfdfe9$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $e7cd9ff8a2bfdfe9$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $e7cd9ff8a2bfdfe9$export$2e2bcd8739ae039 = $e7cd9ff8a2bfdfe9$var$ValueContainerWrapper;
module.exports["default"] = $e7cd9ff8a2bfdfe9$export$2e2bcd8739ae039;

});

parcelRegister("d1LXW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gdv5Z = parcelRequire("gdv5Z");


var $3hOY6 = parcelRequire("3hOY6");


var $3gadb = parcelRequire("3gadb");


var $42omo = parcelRequire("42omo");


var $gIEXj = parcelRequire("gIEXj");


var $5MuqH = parcelRequire("5MuqH");


var $8bByc = parcelRequire("8bByc");


var $gQDzG = parcelRequire("gQDzG");


var $5SlZw = parcelRequire("5SlZw");


var $2OK2a = parcelRequire("2OK2a");


var $6O3OC = parcelRequire("6O3OC");


var $9xsgQ = parcelRequire("9xsgQ");

const $5421d1d84d0948a5$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gIEXj.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $5421d1d84d0948a5$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $6O3OC.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MuqH.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $6O3OC.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gIEXj.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $6O3OC.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5SlZw.default), {
        email: data,
        emailValidity: (0, $9xsgQ.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $6O3OC.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bByc.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $6O3OC.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQDzG.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $6O3OC.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2OK2a.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $5421d1d84d0948a5$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), tooltipProps, $5421d1d84d0948a5$var$dataOption(props)));
    return $5421d1d84d0948a5$var$dataOption(props);
};
const $5421d1d84d0948a5$export$36d18380658d5d20 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(10);
    const t0 = props;
    let t1;
    if ($[0] !== props) {
        t1 = $5421d1d84d0948a5$var$defaultOption(props);
        $[0] = props;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = $5421d1d84d0948a5$var$dataOptionWithTooltip(props);
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: t1
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t0 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, t0, t3);
        $[7] = t0;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
        fallback: $5421d1d84d0948a5$var$defaultOption(props)
    }, $5421d1d84d0948a5$var$dataOptionWithTooltip(props)));
module.exports["Option"] = $5421d1d84d0948a5$export$36d18380658d5d20;

});

parcelRegister("gIEXj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1wHV6 = parcelRequire("1wHV6");


var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $a1Cju = parcelRequire("a1Cju");


var $a3dA4 = parcelRequire("a3dA4");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $dh538 = parcelRequire("dh538");

class $ca21a62b4eb173f5$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a1Cju.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $a1Cju.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)")
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a3dA4.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $6O3OC.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)";
                result.push(/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $a1Cju.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a3dA4.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $a1Cju.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)")
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType, icon: icon, iconColor: iconColor }, status: status } = this.props;
            const appearance = (0, $dh538.fg)('platform-component-visual-refresh') ? 'medium' : 'big';
            if (icon) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gElw0.AvatarOrIcon), {
                appearance: appearance,
                icon: icon,
                iconColor: iconColor,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $1wHV6.default)(appType)
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: appearance,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $1wHV6.default)(appType)
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
module.exports["UserOption"] = $ca21a62b4eb173f5$export$8e59f78010871662;

});

parcelRegister("a1Cju", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5nBzc = parcelRequire("5nBzc");


var $3WVxj = parcelRequire("3WVxj");


var $6O3OC = parcelRequire("6O3OC");


var $dh538 = parcelRequire("dh538");

function $96ea07b7daa86f4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $96ea07b7daa86f4d$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $96ea07b7daa86f4d$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $9K4OG.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $96ea07b7daa86f4d$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $9K4OG.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $96ea07b7daa86f4d$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $9K4OG.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $96ea07b7daa86f4d$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
const $96ea07b7daa86f4d$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderTag = ()=>{
        if ((0, $6O3OC.isLozengeText)(lozenge) && !lozenge.isBold) {
            const color = lozenge.appearance ? $96ea07b7daa86f4d$var$lozengeAppearanceToTagColor[lozenge.appearance] : 'standard';
            const tag = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3WVxj.default), {
                text: lozenge.text,
                color: color,
                isRemovable: false,
                migration_fallback: "lozenge"
            });
            if (lozenge.tooltip) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
                fallback: tag
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($96ea07b7daa86f4d$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, tag));
            return tag;
        }
        return renderLozenge();
    };
    const renderLozenge = ()=>{
        if ((0, $6O3OC.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
                fallback: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($96ea07b7daa86f4d$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $96ea07b7daa86f4d$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$optionWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$additionalInfo
    }, (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? renderTag() : renderLozenge())));
};
module.exports["textWrapper"] = $96ea07b7daa86f4d$export$aa6223da92b253dd;
module.exports["AvatarItemOption"] = $96ea07b7daa86f4d$export$164a9d9b3b86dd0c;

});

parcelRegister("a3dA4", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $9b44487d553c26e3$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}
module.exports["HighlightText"] = $9b44487d553c26e3$export$bb02e7bc6e1a7119;

});

parcelRegister("5MuqH", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $9552d5b64b4732c1$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("lrpeu")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $9552d5b64b4732c1$export$2e2bcd8739ae039 = $9552d5b64b4732c1$var$AsyncExternalUserOption;
module.exports["default"] = $9552d5b64b4732c1$export$2e2bcd8739ae039;

});

parcelRegister("lrpeu", function(module, exports) {

let $f9bfb14bc74a646f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f9bfb14bc74a646f$var$load("zSp86"),
    $f9bfb14bc74a646f$var$load("faXeM")
]).then(()=>parcelRequire('antvm'));

});

parcelRegister("8bByc", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $7087fdc05d26f437$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("efg1X")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $7087fdc05d26f437$export$2e2bcd8739ae039 = $7087fdc05d26f437$var$AsyncTeamOption;
module.exports["default"] = $7087fdc05d26f437$export$2e2bcd8739ae039;

});

parcelRegister("efg1X", function(module, exports) {

let $a5eee6b7b14d7452$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5eee6b7b14d7452$var$load("7eOUa").then(()=>parcelRequire('3Ylqf'));

});

parcelRegister("gQDzG", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b48b06ade47a1f85$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("jNY3N")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $b48b06ade47a1f85$export$2e2bcd8739ae039 = $b48b06ade47a1f85$var$AsyncGroupOption;
module.exports["default"] = $b48b06ade47a1f85$export$2e2bcd8739ae039;

});

parcelRegister("jNY3N", function(module, exports) {

let $e6b12e9eee2c8d12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6b12e9eee2c8d12$var$load("9zjWJ").then(()=>parcelRequire('g2CU3'));

});

parcelRegister("5SlZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b3aa7260631192b5$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("e2jHL")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $b3aa7260631192b5$export$2e2bcd8739ae039 = $b3aa7260631192b5$var$AsyncEmailOption;
module.exports["default"] = $b3aa7260631192b5$export$2e2bcd8739ae039;

});

parcelRegister("e2jHL", function(module, exports) {

let $a380898d18b524af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a380898d18b524af$var$load("cwwPf").then(()=>parcelRequire('gqFgq'));

});

parcelRegister("2OK2a", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8b75c704d969ea14$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hilZh")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $8b75c704d969ea14$export$2e2bcd8739ae039 = $8b75c704d969ea14$var$AsyncCustomOption;
module.exports["default"] = $8b75c704d969ea14$export$2e2bcd8739ae039;

});

parcelRegister("hilZh", function(module, exports) {

let $c9752c5bfc29a902$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9752c5bfc29a902$var$load("3a4K1").then(()=>parcelRequire('1oHUa'));

});

parcelRegister("9xsgQ", function(module, exports) {
const $bade09abd4a5fb04$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $bade09abd4a5fb04$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $bade09abd4a5fb04$export$371e338370561054 = (inputText)=>{
    if (inputText.match($bade09abd4a5fb04$var$validRegex)) return 'VALID';
    if (inputText.match($bade09abd4a5fb04$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};
module.exports["isValidEmail"] = $bade09abd4a5fb04$export$371e338370561054;

});

parcelRegister("biJXh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3hOY6 = parcelRequire("3hOY6");


var $5nBzc = parcelRequire("5nBzc");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $1wHV6 = parcelRequire("1wHV6");


var $dh538 = parcelRequire("dh538");


var $cO3Oi = parcelRequire("cO3Oi");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $3aPpx = parcelRequire("3aPpx");

const $c82e4369df94e7c9$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syazi7uo _1reo15vq _1bto1l2s _o5721q9c",
    archivedLozengeWrapper: "_1e0c1txw _19bv1b66"
};
const $c82e4369df94e7c9$var$ElementAfter = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    const { data: t0, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const { data: data } = t0;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $6O3OC.isTeam)(data) && data.verified || (0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) {
        const t1 = data.includeTeamsUpdates ? "small" : "medium";
        let t2;
        if ($[0] !== t1) {
            t2 = /*#__PURE__*/ $42omo.createElement((0, $cO3Oi.VerifiedTeamIcon), {
                size: t1
            });
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    return null;
} : (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $6O3OC.isTeam)(data) && data.verified || (0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ $42omo.createElement((0, $cO3Oi.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
const $c82e4369df94e7c9$export$1949dac661ba6e3a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(9);
    const { data: t0, selectProps: t1 } = props;
    const { label: label, data: data } = t0;
    const { appearance: appearance, isFocused: isFocused } = t1;
    let t2;
    if ($[0] !== data) {
        t2 = (0, $6O3OC.isTeam)(data) && data?.state === "DISBANDED" && (0, $dh538.fg)("enable-sup-archive-experience");
        $[0] = data;
        $[1] = t2;
    } else t2 = $[1];
    const canShowArchivedLozenge = t2;
    let t3;
    if ($[2] !== appearance || $[3] !== canShowArchivedLozenge || $[4] !== data || $[5] !== isFocused || $[6] !== label || $[7] !== props) {
        t3 = !isFocused ? /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            xcss: $c82e4369df94e7c9$var$styles.avatarItem
        }, data.icon ? /*#__PURE__*/ $42omo.createElement((0, $gElw0.AvatarOrIcon), {
            icon: data.icon,
            iconColor: data.iconColor,
            src: (0, $6O3OC.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $6O3OC.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $1wHV6.default)(data.appType)
        }) : /*#__PURE__*/ $42omo.createElement((0, $daWcu.SizeableAvatar), {
            src: (0, $6O3OC.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $6O3OC.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $1wHV6.default)(data.appType)
        }), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $c82e4369df94e7c9$var$styles.avatarItem
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $c82e4369df94e7c9$var$styles.avatarItemTextWrapper
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $c82e4369df94e7c9$var$styles.avatarItemText
        }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center"
        }, label, /*#__PURE__*/ $42omo.createElement($c82e4369df94e7c9$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $c82e4369df94e7c9$var$styles.archivedLozengeWrapper
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: "default"
        }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).archivedLozenge))) : null)))))) : null;
        $[2] = appearance;
        $[3] = canShowArchivedLozenge;
        $[4] = data;
        $[5] = isFocused;
        $[6] = label;
        $[7] = props;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    const canShowArchivedLozenge = (0, $6O3OC.isTeam)(data) && data?.state === 'DISBANDED' && (0, $dh538.fg)('enable-sup-archive-experience');
    return !isFocused ? /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $c82e4369df94e7c9$var$styles.avatarItem
    }, data.icon ? /*#__PURE__*/ $42omo.createElement((0, $gElw0.AvatarOrIcon), {
        icon: data.icon,
        iconColor: data.iconColor,
        src: (0, $6O3OC.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $1wHV6.default)(data.appType)
    }) : /*#__PURE__*/ $42omo.createElement((0, $daWcu.SizeableAvatar), {
        src: (0, $6O3OC.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $1wHV6.default)(data.appType)
    }), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c82e4369df94e7c9$var$styles.avatarItem
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $c82e4369df94e7c9$var$styles.avatarItemTextWrapper
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c82e4369df94e7c9$var$styles.avatarItemText
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center"
    }, label, /*#__PURE__*/ $42omo.createElement($c82e4369df94e7c9$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $c82e4369df94e7c9$var$styles.archivedLozengeWrapper
    }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
        appearance: "default"
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $3aPpx.messages).archivedLozenge))) : null)))))) : null;
};
module.exports["SingleValue"] = $c82e4369df94e7c9$export$1949dac661ba6e3a;

});

parcelRegister("gtKKr", function(module, exports) {
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

function $d235b09878379c1c$var$_defineProperty(e, r, t) {
    return (r = $d235b09878379c1c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d235b09878379c1c$var$_toPropertyKey(t) {
    var i = $d235b09878379c1c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d235b09878379c1c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d235b09878379c1c$var$inputStyles = {
    root: "_5ce61rpy _1ir3kb7n _h5gq1rpy"
};
class $d235b09878379c1c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $d235b09878379c1c$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args); // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        $d235b09878379c1c$var$_defineProperty(this, "handleKeyPress", (e)=>{
            if (e.key === 'Enter') e.preventDefault();
             //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        });
    }
}
module.exports["Input"] = $d235b09878379c1c$export$f5b8910cec6cf069;

});

parcelRegister("95uM8", function(module, exports) {
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $gElw0 = parcelRequire("gElw0");


var $daWcu = parcelRequire("daWcu");


var $5zTZv = parcelRequire("5zTZv");


var $1wHV6 = parcelRequire("1wHV6");

function $32eecf62664383f6$var$_defineProperty(e, r, t) {
    return (r = $32eecf62664383f6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $32eecf62664383f6$var$_toPropertyKey(t) {
    var i = $32eecf62664383f6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $32eecf62664383f6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $32eecf62664383f6$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf"
};
const $32eecf62664383f6$var$placeholderIconContainer = null;
const $32eecf62664383f6$var$wrapperStyle = null;
const $32eecf62664383f6$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $32eecf62664383f6$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5zTZv.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).ValueContainer, {
            ...valueContainerProps,
            xcss: $32eecf62664383f6$var$valueContainerStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_nd5l1kqh _19bv12x7 _vwz4idpf"
            ])
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        $32eecf62664383f6$var$_defineProperty(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) {
                const userData = $32eecf62664383f6$var$showUserAvatar(inputValue, value) ? value.data : undefined;
                if (userData?.icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gElw0.AvatarOrIcon), {
                    appearance: appearance,
                    icon: userData.icon,
                    iconColor: userData.iconColor,
                    type: placeholderAvatar,
                    src: userData.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $1wHV6.default)(userData.appType) : undefined
                });
                 // Fallback to original behavior
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daWcu.SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: userData?.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $1wHV6.default)(userData.appType) : undefined
                });
            }
            return null;
        }); //@ts-ignore react-select unsupported props
        $32eecf62664383f6$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        $32eecf62664383f6$var$_defineProperty(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $gMc0m.default)([
                    "_16jlkb7n"
                ])
            }, children) : children;
        });
    }
}
module.exports["SingleValueContainer"] = $32eecf62664383f6$export$afa5f855316c6a48;

});

parcelRegister("aoWT3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtKKr = parcelRequire("gtKKr");

class $66df8f81b00f76a0$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtKKr.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
module.exports["PopupInput"] = $66df8f81b00f76a0$export$d8edbfd510a7db82;

});

parcelRegister("91jwt", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $8LA5n = parcelRequire("8LA5n");

function $6b1648b7e3dcb30f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b1648b7e3dcb30f$var$controlWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $6b1648b7e3dcb30f$var$labelStyle = {
    name: "14uum76",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);padding-bottom:var(--ds-space-050, 4px);padding-left:var(--ds-space-0, 0px);padding-right:var(--ds-space-0, 0px);padding-top:var(--ds-space-250, 20px)"
};
class $6b1648b7e3dcb30f$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6b1648b7e3dcb30f$var$controlWrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6b1648b7e3dcb30f$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8LA5n.default), this.props));
    }
}
module.exports["PopupControl"] = $6b1648b7e3dcb30f$export$a0cb1b4352357fcc;

});

parcelRegister("8LA5n", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $1bHXt = parcelRequire("1bHXt");

const $c39fb557d4d2ab16$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1v1w _bfhk1j9a _4cvx1v1w _irr31j9a",
    disabled: "_irr3187o",
    subtle: "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6drsbi _bfhk1j9a _p12f1osq _14regrf3 _4cvxrsbi _irr3l4ek _1a98zg3v",
    compact: "_1tke1wug"
};
const $c39fb557d4d2ab16$var$Control = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(9);
    const isCompact = props.appearance === "compact";
    const t0 = isCompact && $c39fb557d4d2ab16$var$controlStyles.compact;
    const t1 = (props.selectProps.subtle || props.selectProps.noBorder) && $c39fb557d4d2ab16$var$controlStyles.subtle;
    const t2 = props.isFocused && $c39fb557d4d2ab16$var$controlStyles.focused;
    const t3 = props.isInvalid && $c39fb557d4d2ab16$var$controlStyles.invalid;
    const t4 = props.isDisabled && $c39fb557d4d2ab16$var$controlStyles.disabled;
    let t5;
    if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
        t5 = (0, $1bHXt.cx)($c39fb557d4d2ab16$var$controlStyles.root, t0, t1, t2, t3, t4);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== props || $[7] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
            ...props,
            xcss: t5
        });
        $[6] = props;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($c39fb557d4d2ab16$var$controlStyles.root, isCompact && $c39fb557d4d2ab16$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $c39fb557d4d2ab16$var$controlStyles.subtle, props.isFocused && $c39fb557d4d2ab16$var$controlStyles.focused, props.isInvalid && $c39fb557d4d2ab16$var$controlStyles.invalid, props.isDisabled && $c39fb557d4d2ab16$var$controlStyles.disabled)
    });
};
var $c39fb557d4d2ab16$export$2e2bcd8739ae039 = $c39fb557d4d2ab16$var$Control;
module.exports["default"] = $c39fb557d4d2ab16$export$2e2bcd8739ae039;

});

parcelRegister("8lAE4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $9K4OG = parcelRequire("9K4OG");

const $d10d1e7e5aa26e90$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $d10d1e7e5aa26e90$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hOY6.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $d10d1e7e5aa26e90$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
module.exports["Menu"] = $d10d1e7e5aa26e90$export$d9b273488cd8ce6f;

});

parcelRegister("dTofT", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $9xsgQ = parcelRequire("9xsgQ");


var $6O3OC = parcelRequire("6O3OC");

const $bfc99c5b192cefdf$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $bfc99c5b192cefdf$var$isValidNewOption = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(inputValue)=>inputValue && $bfc99c5b192cefdf$var$validOption.includes(isValidEmail(inputValue));
const $bfc99c5b192cefdf$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $RMvle.EmailType)
        }
    });
const $bfc99c5b192cefdf$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $bfc99c5b192cefdf$var$isOptionDisabled = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(option)=>{
        if ((0, $6O3OC.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $bfc99c5b192cefdf$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $bfc99c5b192cefdf$var$isValidNewOption(isValidEmail),
        getNewOptionData: $bfc99c5b192cefdf$var$getNewOptionData,
        formatCreateLabel: $bfc99c5b192cefdf$var$formatCreateLabel,
        isOptionDisabled: $bfc99c5b192cefdf$var$isOptionDisabled(isValidEmail)
    };
}
const $bfc99c5b192cefdf$export$36f97d8afa97203d = (0, $2XqLN.default)($bfc99c5b192cefdf$var$creatableProps);
module.exports["getCreatableProps"] = $bfc99c5b192cefdf$export$36f97d8afa97203d;

});

parcelRegister("bYlb2", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $9xsgQ = parcelRequire("9xsgQ");


var $6O3OC = parcelRequire("6O3OC");

const $981facf0cd076fa1$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $981facf0cd076fa1$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $981facf0cd076fa1$var$getNewOptionData = (isValidEmail = (0, $9xsgQ.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $981facf0cd076fa1$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $RMvle.EmailType),
                suggestion: true
            }
        };
    };
const $981facf0cd076fa1$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $981facf0cd076fa1$var$isOptionDisabled = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(option)=>{
        if ((0, $6O3OC.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $981facf0cd076fa1$export$34b9dd2dd6a225e5 = (0, $2XqLN.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $981facf0cd076fa1$var$isValidNewOption,
        getNewOptionData: $981facf0cd076fa1$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $981facf0cd076fa1$var$formatCreateLabel,
        isOptionDisabled: $981facf0cd076fa1$var$isOptionDisabled(isValidEmail)
    }));
module.exports["getCreatableSuggestedEmailProps"] = $981facf0cd076fa1$export$34b9dd2dd6a225e5;

});

parcelRegister("39zOH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $czxno = parcelRequire("czxno");

const $f33aff4e4306ad48$var$EMPTY = {};
const $f33aff4e4306ad48$var$useI18n = (0, $4pOgL.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $frIzR.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($f33aff4e4306ad48$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f33aff4e4306ad48$var$EMPTY);
            (0, $czxno.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f33aff4e4306ad48$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($f33aff4e4306ad48$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($f33aff4e4306ad48$var$EMPTY);
        (0, $czxno.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f33aff4e4306ad48$var$MessagesIntlProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    const intl = (0, $aXWIB.useIntl)();
    const { children: children } = props;
    const messages = $f33aff4e4306ad48$var$useI18n(intl.locale);
    const t0 = intl.messages;
    let t1;
    if ($[0] !== messages || $[1] !== t0) {
        t1 = {
            ...t0,
            ...messages
        };
        $[0] = messages;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const mergedMessages = t1;
    let t2;
    if ($[3] !== children || $[4] !== intl.locale || $[5] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
        $[3] = children;
        $[4] = intl.locale;
        $[5] = mergedMessages;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const intl = (0, $aXWIB.useIntl)();
    const { children: children } = props;
    const messages = $f33aff4e4306ad48$var$useI18n(intl.locale);
    const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $f33aff4e4306ad48$export$2e2bcd8739ae039 = $f33aff4e4306ad48$var$MessagesIntlProvider;
function $f33aff4e4306ad48$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f33aff4e4306ad48$export$2e2bcd8739ae039;

});

parcelRegister("czxno", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $4ae2a92de5b04374$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("gGm07")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("iMgoY")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("a2F4a")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("exio3")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ht5Af")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("67KWz")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("2ITUY")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bmV2y")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("bDfHw")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("l6Jrp")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("5Fgxz")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("giE6R")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aFqW6")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("6qm5B")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4pTGn")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5KU7n")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6Q6st")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("hfezP")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("5lXJD")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("3NE2V")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("csvdv")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("7xuSk")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("43nDx")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("iV5JJ")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cnB93")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("vqivz")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("6yfCT")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("1XdJ8")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jUGvI")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("cg7pQ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $4ae2a92de5b04374$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("exio3")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $4ae2a92de5b04374$export$d0a3169680473b6c;

});

parcelRegister("gGm07", function(module, exports) {

let $c251a28321a837d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c251a28321a837d3$var$load("9J4KV").then(()=>parcelRequire('g1PaI'));

});

parcelRegister("iMgoY", function(module, exports) {

let $dab96ec43e6f3eb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab96ec43e6f3eb4$var$load("8Y9JE").then(()=>parcelRequire('5cPWG'));

});

parcelRegister("a2F4a", function(module, exports) {

let $74f9f22fcdef1db1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74f9f22fcdef1db1$var$load("gWrRN").then(()=>parcelRequire('1YU5Y'));

});

parcelRegister("exio3", function(module, exports) {

let $a95269083b6eacd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a95269083b6eacd9$var$load("irKcy").then(()=>parcelRequire('6aEWI'));

});

parcelRegister("ht5Af", function(module, exports) {

let $cb7979ea7781b247$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7979ea7781b247$var$load("1aghR").then(()=>parcelRequire('97wEb'));

});

parcelRegister("67KWz", function(module, exports) {

let $4757cf8a3567ee77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4757cf8a3567ee77$var$load("3jFnE").then(()=>parcelRequire('F3yzi'));

});

parcelRegister("2ITUY", function(module, exports) {

let $1fbb10fa632caa58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fbb10fa632caa58$var$load("11Khz").then(()=>parcelRequire('ewRdG'));

});

parcelRegister("bmV2y", function(module, exports) {

let $846dfec790105370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $846dfec790105370$var$load("ap0LY").then(()=>parcelRequire('IpO3b'));

});

parcelRegister("bDfHw", function(module, exports) {

let $877f84210d06b4a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $877f84210d06b4a6$var$load("34Ma8").then(()=>parcelRequire('cp7FA'));

});

parcelRegister("l6Jrp", function(module, exports) {

let $f5dd68287f6311f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5dd68287f6311f0$var$load("lBwDa").then(()=>parcelRequire('kADLe'));

});

parcelRegister("5Fgxz", function(module, exports) {

let $41fd9caed43226bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $41fd9caed43226bf$var$load("32Pvr").then(()=>parcelRequire('bVNYH'));

});

parcelRegister("giE6R", function(module, exports) {

let $bddd70b947d92280$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bddd70b947d92280$var$load("b7bFd").then(()=>parcelRequire('3MhWk'));

});

parcelRegister("aFqW6", function(module, exports) {

let $7c42a0a6d53b297d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c42a0a6d53b297d$var$load("6h8Ae").then(()=>parcelRequire('461Di'));

});

parcelRegister("6qm5B", function(module, exports) {

let $4ad64e444a7941dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ad64e444a7941dc$var$load("dW8Ws").then(()=>parcelRequire('2gGqw'));

});

parcelRegister("4pTGn", function(module, exports) {

let $3374b0a133257fc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3374b0a133257fc8$var$load("fJZdm").then(()=>parcelRequire('b0fTR'));

});

parcelRegister("5KU7n", function(module, exports) {

let $0114d9ed76b2fdf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0114d9ed76b2fdf6$var$load("kfTIE").then(()=>parcelRequire('e3XiS'));

});

parcelRegister("6Q6st", function(module, exports) {

let $4fac9be16220acb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fac9be16220acb5$var$load("b8M9e").then(()=>parcelRequire('k1tgV'));

});

parcelRegister("hfezP", function(module, exports) {

let $c8df2505f9f73711$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8df2505f9f73711$var$load("jMchi").then(()=>parcelRequire('6tsQH'));

});

parcelRegister("5lXJD", function(module, exports) {

let $3e5d400f8ffeb9df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e5d400f8ffeb9df$var$load("2xsmF").then(()=>parcelRequire('8LiMQ'));

});

parcelRegister("3NE2V", function(module, exports) {

let $2c450305321bb93d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c450305321bb93d$var$load("hHyCx").then(()=>parcelRequire('5jasV'));

});

parcelRegister("csvdv", function(module, exports) {

let $9120508f7983bf02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9120508f7983bf02$var$load("gw4Pw").then(()=>parcelRequire('9yLSY'));

});

parcelRegister("7xuSk", function(module, exports) {

let $57d390a3a4646107$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57d390a3a4646107$var$load("8rhcn").then(()=>parcelRequire('abrYV'));

});

parcelRegister("43nDx", function(module, exports) {

let $2f39c70088433ef0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f39c70088433ef0$var$load("fh5Vk").then(()=>parcelRequire('hBPGx'));

});

parcelRegister("iV5JJ", function(module, exports) {

let $dc62000857df1f57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc62000857df1f57$var$load("aP4eD").then(()=>parcelRequire('8ch0x'));

});

parcelRegister("cnB93", function(module, exports) {

let $903472462aaf91f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $903472462aaf91f1$var$load("aJWAE").then(()=>parcelRequire('7qoEH'));

});

parcelRegister("vqivz", function(module, exports) {

let $05e74b813d03b672$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05e74b813d03b672$var$load("b96A2").then(()=>parcelRequire('6WyHk'));

});

parcelRegister("6yfCT", function(module, exports) {

let $4c520a22aa4bea6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c520a22aa4bea6b$var$load("g0ukK").then(()=>parcelRequire('1CggD'));

});

parcelRegister("1XdJ8", function(module, exports) {

let $16c5f30bb0fb803b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16c5f30bb0fb803b$var$load("8DuKk").then(()=>parcelRequire('d2VHY'));

});

parcelRegister("jUGvI", function(module, exports) {

let $e7f4390275d6775d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7f4390275d6775d$var$load("5aSRq").then(()=>parcelRequire('f5vpO'));

});

parcelRegister("cg7pQ", function(module, exports) {

let $8eccbb4928f4b8f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eccbb4928f4b8f1$var$load("eQT38").then(()=>parcelRequire('5Olm2'));

});

parcelRegister("aahZc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $60cba41939987423$var$ExusUserSourceContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $60cba41939987423$export$bcd5c65b586ee3c3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { fetchUserSource: fetchUserSource, children: children } = t0;
    let t1;
    if ($[0] !== fetchUserSource) {
        t1 = {
            fetchUserSource: fetchUserSource
        };
        $[0] = fetchUserSource;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60cba41939987423$var$ExusUserSourceContext.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60cba41939987423$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $60cba41939987423$export$c6c0c1a2bac363f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (accountId, shouldFetchSources, existingSources)=>{
    const $ = (0, $frIzR.c)(19);
    const { fetchUserSource: fetchUserSource } = (0, $42omo.useContext)($60cba41939987423$var$ExusUserSourceContext);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [externalSources, setExternalSources] = (0, $42omo.useState)(t0);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    let t1;
    bb0: {
        if (typeof AbortController === "undefined") {
            t1 = undefined;
            break bb0;
        }
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = new AbortController();
            $[1] = t2;
        } else t2 = $[1];
        t1 = t2;
    }
    const abortController = t1;
    let t2;
    let t3;
    if ($[2] !== accountId || $[3] !== fetchUserSource || $[4] !== shouldFetchSources) {
        t2 = ()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources_0)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources_0.map($60cba41939987423$var$_temp);
                setExternalSources(externalSourceTypes);
            }).catch((error_0)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error_0);
            });
            return cleanup;
        };
        t3 = [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ];
        $[2] = accountId;
        $[3] = fetchUserSource;
        $[4] = shouldFetchSources;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[7] !== existingSources || $[8] !== externalSources) {
        let t5;
        if ($[10] !== existingSources) {
            t5 = existingSources ?? [];
            $[10] = existingSources;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== externalSources || $[13] !== t5) {
            t6 = new Set([
                ...t5,
                ...externalSources
            ]);
            $[12] = externalSources;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        t4 = Array.from(t6);
        $[7] = existingSources;
        $[8] = externalSources;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[15] !== error || $[16] !== loading || $[17] !== t4) {
        t5 = {
            sources: t4,
            loading: loading,
            error: error
        };
        $[15] = error;
        $[16] = loading;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $42omo.useContext)($60cba41939987423$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const abortController = (0, $42omo.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources_0)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources_0.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error_0)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error_0);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $42omo.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};
function $60cba41939987423$var$_temp(source) {
    return source.sourceType;
}
module.exports["ExusUserSourceProvider"] = $60cba41939987423$export$bcd5c65b586ee3c3;
module.exports["useUserSource"] = $60cba41939987423$export$c6c0c1a2bac363f;

});

parcelRegister("4XUIT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jb7rL = parcelRequire("jb7rL");


var $8lfDt = parcelRequire("8lfDt");


var $kjDWr = parcelRequire("kjDWr");

const $632da732d9a46658$var$CreatableSelect = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const creatableProps = (0, $kjDWr.default)(props);
    const selectProps = (0, $8lfDt.default)(creatableProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jb7rL.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$632da732d9a46658$export$2e2bcd8739ae039 = $632da732d9a46658$var$CreatableSelect;
module.exports["default"] = $632da732d9a46658$export$2e2bcd8739ae039;

});

parcelRegister("8lfDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0dda67548c7e875$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $i7y6n = parcelRequire("i7y6n");

var $lwAOf = parcelRequire("lwAOf");


var $h0cph = parcelRequire("h0cph");


var $ffxIv = parcelRequire("ffxIv");

const $a0dda67548c7e875$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $a0dda67548c7e875$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$a0dda67548c7e875$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$a0dda67548c7e875$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $a0dda67548c7e875$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $a0dda67548c7e875$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $a0dda67548c7e875$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $a0dda67548c7e875$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $lwAOf.getOptionValue), getOptionLabel: getOptionLabel = (0, $i7y6n.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $42omo.useMemo)(()=>isValidNewOption(inputValue, (0, $h0cph.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $42omo.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $42omo.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $ffxIv.valueTernary)(isMulti, [
                    ...(0, $h0cph.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("7rus4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8JuIs = parcelRequire("8JuIs");


var $44RZm = parcelRequire("44RZm");


var $hnmbx = parcelRequire("hnmbx");

const $e8ee834aaf2971c0$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $hnmbx.useUFOConcurrentExperience)((0, $hnmbx.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnmbx.UfoErrorBoundary), {
        id: ufoId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44RZm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8JuIs.SmartUserPicker), props)));
};
var $e8ee834aaf2971c0$export$2e2bcd8739ae039 = $e8ee834aaf2971c0$var$SmartUserPickerWithIntlProvider;
module.exports["default"] = $e8ee834aaf2971c0$export$2e2bcd8739ae039;

});

parcelRegister("8JuIs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $dQl1W = parcelRequire("dQl1W");


var $1DWH0 = parcelRequire("1DWH0");


var $2XqLN = parcelRequire("2XqLN");


var $aXWIB = parcelRequire("aXWIB");


var $28cxD = parcelRequire("28cxD");


var $kSKAi = parcelRequire("kSKAi");

var $6O3OC = parcelRequire("6O3OC");

var $9xsgQ = parcelRequire("9xsgQ");


var $dh538 = parcelRequire("dh538");


var $8CB5E = parcelRequire("8CB5E");


var $44RZm = parcelRequire("44RZm");


var $b4tkb = parcelRequire("b4tkb");


var $5kTPO = parcelRequire("5kTPO");

var $52K9w = parcelRequire("52K9w");


var $hnmbx = parcelRequire("hnmbx");

const $40c1c58d6de383a6$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $40c1c58d6de383a6$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $40c1c58d6de383a6$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.userbaseId !== newContext.userbaseId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $40c1c58d6de383a6$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $40c1c58d6de383a6$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $40c1c58d6de383a6$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $40c1c58d6de383a6$var$isEmailQuery = (query)=>{
    return (0, $9xsgQ.isValidEmail)(query.trim()) === 'VALID';
};
class $40c1c58d6de383a6$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    async componentDidMount() {
        try {
            const value = await (0, $52K9w.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId, {
                tenantId: this.props.siteId,
                activationId: this.props.activationId
            });
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $dQl1W.v4)();
            this.fireEvent((0, $8CB5E.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($40c1c58d6de383a6$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $28cxD.UFOExperienceState).FAILED.id,
                (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
                (0, $28cxD.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            const isCurrentQueryEmail = $40c1c58d6de383a6$var$isEmailQuery(this.state.query);
            // Only allow email selection when:
            // 1. The query matches email format (validated by regex)
            // 2. No user/external user matches were found (only teams/groups suggested)
            shouldAllowEmail = isCurrentQueryEmail && !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44RZm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
            ...restProps,
            allowEmail: shouldAllowEmail,
            onInputChange: this.onInputChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            defaultValue: this.state.defaultValue,
            isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
            options: this.filterUsers(),
            menuIsOpen: this.props.menuIsOpen
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        };
        // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false;
        this.optionsShownUfoExperienceInstance = void 0;
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $28cxD.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $8CB5E.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        };
        this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users;
        this.memoizedFilterOptions = (0, $2XqLN.default)(this.filterOptions);
        this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, fetchOptions: fetchOptions, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, verifiedTeams: verifiedTeams, orgId: orgId, userbaseId: userbaseId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, restrictTo: restrictTo, searchQueryFilter: searchQueryFilter, siteId: siteId, isTeamSyncedToGroupDirectoryFilter: isTeamSyncedToGroupDirectoryFilter, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $40c1c58d6de383a6$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    userbaseId: userbaseId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                ...verifiedTeams === true && {
                    verifiedTeams: true
                },
                /*
        	For email-based searches, we have decided to filter out apps.
        	Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
        	when filter is empty, they have been added here to maintain consistency.
        		Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
         */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter,
                ...restrictTo && (0, $dh538.fg)('smart-user-picker-restrict-to-gate') && {
                    restrictTo: restrictTo
                },
                ...isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                }
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $8CB5E.requestUsersEvent));
                let recommendedUsers;
                if (fetchOptions && (0, $dh538.fg)('smart-user-picker-load-options-gate')) recommendedUsers = await fetchOptions(query);
                else if ((0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $5kTPO.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $8CB5E.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $5kTPO.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isUser)(option) || (0, $6O3OC.isExternalUser)(option) || (0, $6O3OC.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isUser)(option) || (0, $6O3OC.isExternalUser)(option)) {
                        if (option.userType === (0, $b4tkb.UserEntityType).DEFAULT || option.userType === (0, $b4tkb.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isGroup)(option) || (0, $6O3OC.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) {
                    // Only count user/external user matches, not teams or groups
                    const userMatches = recommendedUsers.filter((user)=>(0, $6O3OC.isUser)(user) || (0, $6O3OC.isExternalUser)(user));
                    this.lastEmailSearchFoundMatches = userMatches.length > 0;
                } else this.lastEmailSearchFoundMatches = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $8CB5E.successfulRequestUsersEvent), {
                        users: $40c1c58d6de383a6$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $40c1c58d6de383a6$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $40c1c58d6de383a6$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch  {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $8CB5E.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0);
        this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        };
        this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $8CB5E.filterUsersEvent), {
                    filtered: $40c1c58d6de383a6$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $40c1c58d6de383a6$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$40c1c58d6de383a6$var$stringContains(user.name, query));
            this.fireEvent((0, $8CB5E.filterUsersEvent), {
                filtered: $40c1c58d6de383a6$var$getUsersForAnalytics(queryFilteredUsers),
                all: $40c1c58d6de383a6$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        };
        this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $8CB5E.preparedUsersLoadedEvent), {
                users: $40c1c58d6de383a6$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        };
        this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $hnmbx.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
}
// TODO: Smart User picker team will have to add a type annotation here
$40c1c58d6de383a6$export$9b9bd453d1d4e4ce.defaultProps = {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeTeamsUpdates: false,
    includeNonLicensedUsers: false,
    displayEmailInByline: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $40c1c58d6de383a6$var$DEFAULT_DEBOUNCE_TIME_MS,
    userResolvers: [],
    enableEmailSearch: false,
    allowEmailSelectionWhenEmailMatched: true,
    verifiedTeams: false
};
const $40c1c58d6de383a6$export$9eedb6e5d313efdb = (0, $1DWH0.default)()((0, $aXWIB.injectIntl)($40c1c58d6de383a6$export$9b9bd453d1d4e4ce));
module.exports["SmartUserPicker"] = $40c1c58d6de383a6$export$9eedb6e5d313efdb;

});

parcelRegister("8CB5E", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $eWRwJ = parcelRequire("eWRwJ");


var $dQl1W = parcelRequire("dQl1W");

const $652153700385f927$var$packageName = "platform-pkg";
const $652153700385f927$var$packageVersion = "0.0.0-use.local";
const $652153700385f927$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $dQl1W.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $652153700385f927$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $652153700385f927$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $652153700385f927$var$packageName,
            packageVersion: $652153700385f927$var$packageVersion,
            ...attributes
        }
    });
const $652153700385f927$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $652153700385f927$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$652153700385f927$var$createEvent('operational', action, actionSubect, attributes)
    });
const $652153700385f927$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$fbba77127d7cb173 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('requested', 'users', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$bfc020018aa738d0 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$738aca68b593db8e = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$b9358131e14a4b0b = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
module.exports["createAndFireEventInElementsChannel"] = $652153700385f927$export$53eef0dcd9611650;
module.exports["preparedUsersLoadedEvent"] = $652153700385f927$export$185f4c3d9b7ef9bf;
module.exports["mountedWithPrefetchEvent"] = $652153700385f927$export$9cfb4251e50d7b91;
module.exports["filterUsersEvent"] = $652153700385f927$export$fbba77127d7cb173;
module.exports["requestUsersEvent"] = $652153700385f927$export$1762ed8845ff2d9b;
module.exports["successfulRequestUsersEvent"] = $652153700385f927$export$bfc020018aa738d0;
module.exports["failedRequestUsersEvent"] = $652153700385f927$export$738aca68b593db8e;
module.exports["failedUserResolversEvent"] = $652153700385f927$export$b9358131e14a4b0b;

});

parcelRegister("44RZm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lRpQD = parcelRequire("lRpQD");

const $bc4fb65506569ed6$var$EMPTY = {};
const $bc4fb65506569ed6$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($bc4fb65506569ed6$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($bc4fb65506569ed6$var$EMPTY);
        (0, $lRpQD.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $bc4fb65506569ed6$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $bc4fb65506569ed6$var$useI18n(intl.locale);
    const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
const $bc4fb65506569ed6$var$_default_1 = (0, $aXWIB.injectIntl)($bc4fb65506569ed6$var$MessagesIntlProvider);
var $bc4fb65506569ed6$export$2e2bcd8739ae039 = $bc4fb65506569ed6$var$_default_1;
module.exports["default"] = $bc4fb65506569ed6$export$2e2bcd8739ae039;

});

parcelRegister("lRpQD", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $c819b58c07849348$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("bTsn1")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("6GCvk")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("aVRkS")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("9RUlw")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9qWAB")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("hwi20")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ffmF0")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("7akr7")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("dG5bn")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("ixFnS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("b4pNT")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("jY0MO")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("OdTh3")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("9xDn8")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("edhsD")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6HDVJ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("a1EUA")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("6eF92")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("e84Bi")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("i6OJ2")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("b2Ob5")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("epyll")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("87x5R")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("gKeCQ")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("ViznQ")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("gRnrF")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("fTMVb")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("5RDfj")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("g6dca")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $c819b58c07849348$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("9RUlw")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $c819b58c07849348$export$d0a3169680473b6c;

});

parcelRegister("bTsn1", function(module, exports) {

let $8a8ad67e7884d3ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a8ad67e7884d3ee$var$load("9J4KV").then(()=>parcelRequire('cn04M'));

});

parcelRegister("6GCvk", function(module, exports) {

let $4de488764c6cfa0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4de488764c6cfa0a$var$load("8Y9JE").then(()=>parcelRequire('1zktf'));

});

parcelRegister("aVRkS", function(module, exports) {

let $7f58999a79e6349b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f58999a79e6349b$var$load("gWrRN").then(()=>parcelRequire('8wiEy'));

});

parcelRegister("9RUlw", function(module, exports) {

let $72f4c575475b8ff2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72f4c575475b8ff2$var$load("irKcy").then(()=>parcelRequire('gOk31'));

});

parcelRegister("9qWAB", function(module, exports) {

let $6de3fd6373f80610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6de3fd6373f80610$var$load("1aghR").then(()=>parcelRequire('fy2oQ'));

});

parcelRegister("hwi20", function(module, exports) {

let $cc13697e056477b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc13697e056477b4$var$load("11Khz").then(()=>parcelRequire('5oLnX'));

});

parcelRegister("ffmF0", function(module, exports) {

let $b199d5a16bac3489$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b199d5a16bac3489$var$load("ap0LY").then(()=>parcelRequire('lsKPD'));

});

parcelRegister("7akr7", function(module, exports) {

let $537951d668c4233a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $537951d668c4233a$var$load("34Ma8").then(()=>parcelRequire('qBAp9'));

});

parcelRegister("dG5bn", function(module, exports) {

let $9f5337b8d9e430bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f5337b8d9e430bb$var$load("lBwDa").then(()=>parcelRequire('iwM0U'));

});

parcelRegister("ixFnS", function(module, exports) {

let $d7fb6910ad50dffa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7fb6910ad50dffa$var$load("32Pvr").then(()=>parcelRequire('emQB1'));

});

parcelRegister("b4pNT", function(module, exports) {

let $80f415843c58387f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80f415843c58387f$var$load("b7bFd").then(()=>parcelRequire('gsrSx'));

});

parcelRegister("jY0MO", function(module, exports) {

let $e8943b15c1095f0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8943b15c1095f0b$var$load("6h8Ae").then(()=>parcelRequire('fy2dB'));

});

parcelRegister("OdTh3", function(module, exports) {

let $096f71fe6a133344$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $096f71fe6a133344$var$load("dW8Ws").then(()=>parcelRequire('gaGnN'));

});

parcelRegister("9xDn8", function(module, exports) {

let $6f25bca05c93306d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f25bca05c93306d$var$load("fJZdm").then(()=>parcelRequire('h47Xp'));

});

parcelRegister("edhsD", function(module, exports) {

let $a58fd2ef4859e4c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a58fd2ef4859e4c2$var$load("kfTIE").then(()=>parcelRequire('kPwYW'));

});

parcelRegister("6HDVJ", function(module, exports) {

let $4e15bb82c38bbb9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e15bb82c38bbb9b$var$load("b8M9e").then(()=>parcelRequire('2ghCe'));

});

parcelRegister("a1EUA", function(module, exports) {

let $74c9bb98590c44dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74c9bb98590c44dc$var$load("jMchi").then(()=>parcelRequire('5Dvg5'));

});

parcelRegister("6eF92", function(module, exports) {

let $48a3f75c40936ce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48a3f75c40936ce0$var$load("2xsmF").then(()=>parcelRequire('7JChl'));

});

parcelRegister("e84Bi", function(module, exports) {

let $a49561987d0955ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a49561987d0955ea$var$load("hHyCx").then(()=>parcelRequire('iYJQV'));

});

parcelRegister("i6OJ2", function(module, exports) {

let $d2f0228f4b9611b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2f0228f4b9611b3$var$load("gw4Pw").then(()=>parcelRequire('8RsTW'));

});

parcelRegister("b2Ob5", function(module, exports) {

let $80a6cde59d00f370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80a6cde59d00f370$var$load("8rhcn").then(()=>parcelRequire('cpBhe'));

});

parcelRegister("epyll", function(module, exports) {

let $a7de0a56fe167aca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7de0a56fe167aca$var$load("fh5Vk").then(()=>parcelRequire('1qgZZ'));

});

parcelRegister("87x5R", function(module, exports) {

let $5e98a5df9723a0ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e98a5df9723a0ca$var$load("aP4eD").then(()=>parcelRequire('bkrR7'));

});

parcelRegister("gKeCQ", function(module, exports) {

let $c30c498bdaf770fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30c498bdaf770fc$var$load("aJWAE").then(()=>parcelRequire('7VxDp'));

});

parcelRegister("ViznQ", function(module, exports) {

let $0ac3ba8ab2ce85a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ac3ba8ab2ce85a5$var$load("b96A2").then(()=>parcelRequire('aq3KW'));

});

parcelRegister("gRnrF", function(module, exports) {

let $c463c852d03859d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c463c852d03859d2$var$load("g0ukK").then(()=>parcelRequire('djjDV'));

});

parcelRegister("fTMVb", function(module, exports) {

let $b931f0d132593dec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b931f0d132593dec$var$load("8DuKk").then(()=>parcelRequire('7D0E8'));

});

parcelRegister("5RDfj", function(module, exports) {

let $4450586e03add784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4450586e03add784$var$load("5aSRq").then(()=>parcelRequire('cU76k'));

});

parcelRegister("g6dca", function(module, exports) {

let $bb8771308e18862d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb8771308e18862d$var$load("eQT38").then(()=>parcelRequire('5c5SM'));

});

parcelRegister("52K9w", function(module, exports) {

var $RMvle = parcelRequire("RMvle");


var $g2dtt = parcelRequire("g2dtt");


var $5tNjN = parcelRequire("5tNjN");


var $byRSb = parcelRequire("byRSb");


var $1h51z = parcelRequire("1h51z");

const $19437af1da52fb39$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $g2dtt.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $19437af1da52fb39$var$transformJiraUsers : $19437af1da52fb39$var$transformConfluenceUsers);
};
const $19437af1da52fb39$var$transformJiraUsers = (userResponse)=>userResponse.values.map($19437af1da52fb39$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $19437af1da52fb39$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $RMvle.UserType),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $19437af1da52fb39$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($19437af1da52fb39$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $19437af1da52fb39$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $RMvle.UserType),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $19437af1da52fb39$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $1h51z.UNKNOWN)
        };
    });
};
const $19437af1da52fb39$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $19437af1da52fb39$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $byRSb.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $19437af1da52fb39$var$hydrateAccountIds = async (baseUrl, productKey, values, atlAttributes)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $19437af1da52fb39$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $5tNjN.default)(baseUrl, accountIds, {
        product: productKey,
        ...atlAttributes
    });
};
async function $19437af1da52fb39$var$hydrateDefaultValues(baseUrl, value, productKey, siteId, atlAttributes) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$19437af1da52fb39$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $19437af1da52fb39$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$19437af1da52fb39$var$isOptionData(val) && val.type === 'user'), atlAttributes),
        $19437af1da52fb39$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$19437af1da52fb39$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$19437af1da52fb39$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $19437af1da52fb39$var$sortResults(hydratedOptions, values);
}
var $19437af1da52fb39$export$2e2bcd8739ae039 = $19437af1da52fb39$var$hydrateDefaultValues;
module.exports["default"] = $19437af1da52fb39$export$2e2bcd8739ae039;

});

parcelRegister("5tNjN", function(module, exports) {

var $1h51z = parcelRequire("1h51z");


var $5y06K = parcelRequire("5y06K");


var $g2dtt = parcelRequire("g2dtt");

/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $26288bf672f514b3$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $26288bf672f514b3$var$makeRequest = async (url, accountIds, attributionData)=>{
    const query = $26288bf672f514b3$var$buildUsersQuery(accountIds);
    return await (0, $5y06K.graphqlQuery)(url, query, attributionData);
};
const $26288bf672f514b3$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $26288bf672f514b3$var$getHydratedUsers = (baseUrl, userIds, attributionData)=>{
    const url = (0, $g2dtt.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $26288bf672f514b3$var$makeRequest(url, userIds, attributionData).then((data)=>{
            resolve($26288bf672f514b3$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $1h51z.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $26288bf672f514b3$export$2e2bcd8739ae039 = $26288bf672f514b3$var$getHydratedUsers;
module.exports["default"] = $26288bf672f514b3$export$2e2bcd8739ae039;

});

parcelRegister("1h51z", function(module, exports) {
const $690e1ddcc04ff137$export$78244dbb77cfa6b6 = 'Unknown';
const $690e1ddcc04ff137$export$d1f5101c0939e3fe = {
    id: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    name: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    type: 'user'
};
const $690e1ddcc04ff137$export$8144dcfc9025ca57 = {
    id: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    name: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    type: 'team'
};
module.exports["UNKNOWN"] = $690e1ddcc04ff137$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_USER"] = $690e1ddcc04ff137$export$d1f5101c0939e3fe;
module.exports["UNKNOWN_TEAM"] = $690e1ddcc04ff137$export$8144dcfc9025ca57;

});

parcelRegister("5y06K", function(module, exports) {

var $dlFkM = parcelRequire("dlFkM");

const $7113235240a12c5e$var$buildHeaders = (attributionData)=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const atlAttributionHeader = (0, $dlFkM.createAtlAttributionHeader)(attributionData);
    headers.append('atl-attribution', atlAttributionHeader['atl-attribution']);
    return headers;
};
function $7113235240a12c5e$export$74eb8d79ae3e02b5(serviceUrl, query, attributionData) {
    const headers = $7113235240a12c5e$var$buildHeaders(attributionData);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $7113235240a12c5e$export$74eb8d79ae3e02b5;

});

parcelRegister("dlFkM", function(module, exports) {
/**
 * Utility for creating the atl-attribution header for AGG requests
 * Reference: https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
 */ function $d0abc7cae6c404a4$export$14ef296862e3705e({ product: product = 'platform', activationId: activationId, ...props } = {}) {
    const headerData = {
        service: 'smart-experiences/smart-user-picker',
        product: product,
        atlWorkspaceId: activationId && props.tenantId ? `ari:cloud:${product}:${props.tenantId}:workspace/${activationId}` : undefined,
        ...props
    };
    return {
        'atl-attribution': JSON.stringify(headerData)
    };
}
module.exports["createAtlAttributionHeader"] = $d0abc7cae6c404a4$export$14ef296862e3705e;

});

parcelRegister("byRSb", function(module, exports) {

var $g2dtt = parcelRequire("g2dtt");


var $1h51z = parcelRequire("1h51z");

const $5847a110ae2c5370$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl,
        ...team.state && {
            state: team.state
        }
    };
};
const $5847a110ae2c5370$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $g2dtt.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $5847a110ae2c5370$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $1h51z.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $5847a110ae2c5370$export$2e2bcd8739ae039 = $5847a110ae2c5370$var$hydrateTeamFromLegion;
module.exports["default"] = $5847a110ae2c5370$export$2e2bcd8739ae039;

});

parcelRegister("hnmbx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $28cxD = parcelRequire("28cxD");

const $06ae62c086839e8d$var$COMPONENT_NAME = 'smart-user-picker';
const $06ae62c086839e8d$export$df77da4c0210f1c1 = new (0, $9801n.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $06ae62c086839e8d$var$COMPONENT_NAME
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ae62c086839e8d$export$a0e7cca3ab9586eb = new (0, $9801n.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $06ae62c086839e8d$var$COMPONENT_NAME
    },
    type: (0, $iqaft.ExperienceTypes).Operation,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
});
const $06ae62c086839e8d$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $42omo.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $42omo.useEffect)(()=>{
        if (experienceForId.state !== (0, $28cxD.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $28cxD.UFOExperienceState)['STARTED'],
                (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $06ae62c086839e8d$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $06ae62c086839e8d$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["smartUserPickerRenderedUfoExperience"] = $06ae62c086839e8d$export$df77da4c0210f1c1;
module.exports["smartUserPickerOptionsShownUfoExperience"] = $06ae62c086839e8d$export$a0e7cca3ab9586eb;
module.exports["useUFOConcurrentExperience"] = $06ae62c086839e8d$export$e5e0512991825310;
module.exports["UfoErrorBoundary"] = $06ae62c086839e8d$export$5ef1c2550074a375;

});


$parcel$global.rlb("kL5FA")
//# sourceMappingURL=datasourceTableView.5567ef6c.js.map
